<template>
  <div class="sp-template">
    <div class="h-title">批次操作</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">
          <el-row>
            <el-form-item label="批次状态">
              <el-select v-model="conditions.isDone">
                <el-option v-if="in_configs(40712)" label="未完成" value="未完成"></el-option>
                <el-option v-if="in_configs(40713)" label="已完成" value="已完成"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运力名称">
              <el-select v-model.lazy="conditions.capacity">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="(d,i) in capaticyList" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="批次号">
              <el-input v-model.lazy="conditions.batchIdTextArea" type="textarea" placeholder="多个批次号用回车分割"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select class="width-inline" size="small" clearable placeholder="选择类型" v-model="conditions.type">
                    <el-option v-for="(d,i) in batchTypeList" :key="i" :label="d.name" :value="d.id"></el-option>
                </el-select> 
            </el-form-item>
          </el-row>
          <el-collapse-transition>
            <div v-show="isSearchMore">
              <el-row>
                <el-form-item label="板/柜号">
                  <el-input v-model.lazy="conditions.container" placeholder="板/柜号"></el-input>
                </el-form-item>
                <el-form-item label="订单号">
                  <el-input v-model.lazy="conditions.order" placeholder="订单号"></el-input>
                </el-form-item>
                <el-form-item label="其它">
                  <el-input v-model.lazy="conditions.searchTextArea" type="textarea" placeholder="航空公司、代理公司、航空单号、承运商、备注,多个用回车分割"></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="开始日期">
                  <el-date-picker v-model.lazy="conditions.startDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期">
                  <el-date-picker v-model.lazy="conditions.endDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束日期"></el-date-picker>
                </el-form-item>
              </el-row>
            </div>
          </el-collapse-transition>
          <div class="search-form__buttons">
            <el-button v-if="in_configs(40714)" size="small" type="primary" @click="search">搜 索</el-button>
            <el-button v-if="in_configs(40714)" size="small" @click="reset">清 空</el-button>
            <a class="toggle-icon" @click.stop.prevent="isSearchMore = !isSearchMore">
							<b v-show="isSearchMore">隐藏</b><b v-show="!isSearchMore">展开</b>更多搜索条件
            </a>
          </div>
        </el-form>
        <form action="" method="get" target="_blank" id="myform">
        </form>
        <div>
          <el-button v-if="in_configs(40701)" size="small" class="btn-cyan" v-show="false" @click="shipment">出 货</el-button>
          <!-- <el-button size="small" type="primary" @click="intoSupervisoryWarehouse">已入监管仓</el-button> -->
          <el-button v-if="in_configs(40703)" size="small" type="success" v-show="false" @click="showCustomsDeclaration('CUSTOMS_BROKER')">报 关</el-button>
          <!-- <el-button size="small" type="warning" @click="showDeparture">出 发</el-button> -->
          <!-- <el-button size="small" class="btn-cyan" @click="showArrival">到 达</el-button> -->
          <el-button v-if="in_configs(40706)" size="small" type="primary" v-show="false" @click="showCustomsDeclaration('BROKER')">清 关</el-button>
          <!-- <el-button size="small" type="success" @click="showInOverseasWarehouse">入海外仓</el-button> -->
          <!-- <el-button size="small" type="warning" @click="operationDistributionCompleted">分货完成</el-button> -->
        </div>
      </div>
      <div class="table-operate__buttons">
        <el-tabs v-model="conditions.status" @tab-click="onSubmit">
					<el-tab-pane v-if="in_configs(40709)" label="空运" name="AIR_SHIPPING"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40710)" label="海运" name="SEA_SHIPPING"></el-tab-pane>
					<el-tab-pane v-if="in_configs(40711)" label="铁运" name="RAILWAY_SHIPPING"></el-tab-pane>
				</el-tabs>
        <div class="button-groups">
          <el-button size="small" @click="exportBatchBaseData">导出批次基础数据报表</el-button>

          <el-button size="small" @click="customizeDialogVisible = true">自定义列表显示项</el-button>
          <el-button size="small" v-if="in_configs(40730)" @click="batchDetailDialogVisible = true">导出批次明细时间</el-button>
          <el-button size="small" v-if="in_configs(40732)" @click="sonOrderSingOutdialog = true">导出子单签收时间</el-button>
          <el-dropdown style="margin-left: 10px;">
            <el-button size="small">导出订单信息<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="in_configs(40722)" size="small" @click.native="downloadGoodsInfo">导出订单信息表</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(40716) && conditions.status == 'SEA_SHIPPING'" @click.native="downloadSeaOrder" title="导出所选批次中渠道类型设置为'海运'的订单">导出海运订单</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(40717) && conditions.status == 'AIR_SHIPPING'" @click.native="downloadUSAirOrder" title="导出所选批次中渠道目的国家设置为'美国'且渠道类型设置为'空运'的订单">导出美国空运订单</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(40718) && conditions.status == 'SEA_SHIPPING'" @click.native="downloadJPSeaOrder" title="导出所选批次中渠道目的国家设置为'日本'且渠道类型设置为'海运'的订单">导出日本海运订单</el-dropdown-item>
              <el-dropdown-item v-show="in_configs(40719) && conditions.status == 'AIR_SHIPPING'" @click.native="downloadEURAirOrder">导出欧洲空运订单</el-dropdown-item>
              <el-dropdown-item v-if="in_configs(40724)" @click.native="goodsInfoExport()">导出货物信息</el-dropdown-item>
              <el-dropdown-item v-if="in_configs(40727)" @click.native="orderPrintExport()">导出打单表</el-dropdown-item>
              <!-- 40731 -->
              <el-dropdown-item v-if="in_configs(40731)" @click.native="orderShipmentExport()">导出出货跟进表</el-dropdown-item>
              <el-dropdown-item size="small" @click.native="exportInternet()">导出批次上网统计</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="statistics">
        <span class="text">
          <b class="total">总订单量</b>：</span>
        <span class="number">{{amountOrder == null ? 0 : amountOrder}}</span>
      </div>
      <el-table :data="tableData" stripe border @selection-change="handleSelectionChange" style="width: 100%" max-height="800" 
        v-loading="loading" element-loading-text="拼命加载中，请稍候" class="batch-operation__table" >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="批次号"   v-if="customizeShowColumns.id"></el-table-column>
        
        <el-table-column label="类型"   width="100px">
            <template slot-scope="scope">
              {{batchTypeMap[showBatchAttribute(scope.row,"type")]}}
            </template>
          </el-table-column>

        <el-table-column label="航空公司" width="120" :key="1"  v-if="conditions.status == 'AIR_SHIPPING' && customizeShowColumns.airlines">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"airlines")}}</span>
          </template>
        </el-table-column>
        <el-table-column width="120" label="船公司"  :key="2" v-if="conditions.status == 'SEA_SHIPPING' && customizeShowColumns.shippingCompany">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"shipping_company")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="铁路公司" :key="3"  width="120" v-if="conditions.status == 'RAILWAY_SHIPPING' && customizeShowColumns.railwayCompany">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"railway_companies")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="航空单号" width="120" :key="4"  v-if="conditions.status === 'AIR_SHIPPING' && customizeShowColumns.airBill">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"air_waybill")}}</span>
          </template>
        </el-table-column>
            <el-table-column label="上网件数" width="120"  :key="5" v-if="customizeShowColumns.totalPickedUp" align="center">
          <template slot-scope="scope">
             <span>{{scope.row.totalPickedUp}}</span>
          </template>
        </el-table-column>
          <el-table-column label="签收件数" width="120"  :key="6" v-if="customizeShowColumns.totalDelivered" align="center" >
          <template slot-scope="scope">
            <span>{{scope.row.totalDelivered}}</span>
          </template>
        </el-table-column>
          <el-table-column label="上网时效" width="120" align="center" :key="7" v-if="customizeShowColumns.pTime" >
          <template slot-scope="scope" >
            {{ getFounder(scope.row.batchAttribute, showBatchAttribute(scope.row,"inner_delivery_time"))}}
            </template>
        </el-table-column>
          <el-table-column label="签收时效" width="120" :key="8" v-if="customizeShowColumns.STime"  align="center">
          <template slot-scope="scope" >
            {{ getTimer(scope.row.batchAttribute, showBatchAttribute(scope.row,"inner_delivery_time"))}}
            </template>
        </el-table-column>
        <el-table-column label="柜号" width="120" :key="9"  v-if="conditions.status === 'SEA_SHIPPING' && customizeShowColumns.guihao">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"air_waybill")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="代理公司" width="120"  :key="10"  v-if="customizeShowColumns.agencyCompany">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"agency_company")}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="totalOrder" label="订单总数"  :key="11"  v-if="customizeShowColumns.totalOrder"></el-table-column>
        <el-table-column prop="qty" label="箱数"   :key="12" v-if="customizeShowColumns.qty">
           <template slot-scope="scope">
              <el-button type="text" @click.native="showTrackDetail(scope.row.id)">{{scope.row.qty}}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="weight" label="毛重(kg)" :key="13"  v-if="customizeShowColumns.weight">
          <template slot-scope="scope">
            {{toFixed(scope.row.weight,3)}}
          </template>
        </el-table-column>
        <el-table-column label="体积(cbm)" width="100" :key="14"  v-if="customizeShowColumns.volume">
          <template slot-scope="scope">
            {{toFixed(scope.row.volume,6)}}
          </template>
        </el-table-column>
        <el-table-column label="提单重" width="120" :key="15"  v-if="customizeShowColumns.tidanWeight">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"bill_of_lading_weight")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="计费重" width="120" :key="16"  v-if="customizeShowColumns.billingWeight">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"billing_weight")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="出货" align="center" :key="17"  v-if="customizeShowColumns.chuhuo">
          <el-table-column label="时间(外)" width="160" :key="18"  v-if="customizeShowColumns.chuhuo">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"delivery_time")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160" :key="19"  v-if="customizeShowColumns.chuhuo">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_delivery_time")}}
            </template>
          </el-table-column>
          <el-table-column label="运送车辆" :key="20"  v-if="customizeShowColumns.chuhuo">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"transport_vehicles")}}
            </template>
          </el-table-column>
          <el-table-column label="司机" :key="21"  v-if="customizeShowColumns.chuhuo">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"transport_drivers")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="入监管仓时间" align="center" :key="22"  v-if="customizeShowColumns.timeInCustody">
          <el-table-column label="时间(外)" width="160"  :key="23" v-if="customizeShowColumns.timeInCustody">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"time_in_custody")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160"  :key="24" v-if="customizeShowColumns.timeInCustody">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_time_in_custody")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="起飞时间"  align="center" :key="25"  v-if="conditions.status == 'AIR_SHIPPING' && customizeShowColumns.departure">
          <el-table-column label="时间(外)" width="160" :key="26"  v-if="conditions.status == 'AIR_SHIPPING' && customizeShowColumns.departure">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"departure_time")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160" :key="27"  v-if="conditions.status == 'AIR_SHIPPING' && customizeShowColumns.departure">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_departure_time")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="落地时间"  align="center" :key="28"  v-if="conditions.status == 'AIR_SHIPPING' && customizeShowColumns.landing">
          <el-table-column label="时间(外)" width="160"  :key="29" v-if="conditions.status == 'AIR_SHIPPING' && customizeShowColumns.landing">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"landing_time")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160" :key="30"  v-if="conditions.status == 'AIR_SHIPPING' && customizeShowColumns.landing">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_landing_time")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="开船时间"  align="center"  :key="31" v-if="conditions.status == 'SEA_SHIPPING' && customizeShowColumns.kaichuan">
          <el-table-column label="时间(外)" width="160"  :key="32" v-if="conditions.status == 'SEA_SHIPPING' && customizeShowColumns.kaichuan">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"sailing_time")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160" :key="33"  v-if="conditions.status == 'SEA_SHIPPING' && customizeShowColumns.kaichuan">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_sailing_time")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="开车时间"  align="center" :key="34"  v-if="conditions.status == 'RAILWAY_SHIPPING' && customizeShowColumns.driving">
          <el-table-column label="时间(外)" width="160"  :key="35" v-if="conditions.status == 'RAILWAY_SHIPPING' && customizeShowColumns.driving">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"driving_time")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160"  :key="36" v-if="conditions.status == 'RAILWAY_SHIPPING' && customizeShowColumns.driving">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_driving_time")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="到港时间"  align="center"  :key="37" v-if="conditions.status == 'SEA_SHIPPING' && customizeShowColumns.port">
          <el-table-column label="时间(外)" width="160"  :key="38" v-if="conditions.status == 'SEA_SHIPPING' && customizeShowColumns.port">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"port_time")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160"  :key="39" v-if="conditions.status == 'SEA_SHIPPING' && customizeShowColumns.port">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_port_time")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="到达时间"  align="center" :key="40"  v-if="conditions.status == 'RAILWAY_SHIPPING' && customizeShowColumns.arrival">
          <el-table-column label="时间(外)" width="160"  :key="41" v-if="conditions.status == 'RAILWAY_SHIPPING' && customizeShowColumns.arrival">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"arrival_time")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160" :key="42"  v-if="conditions.status == 'RAILWAY_SHIPPING' && customizeShowColumns.arrival">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_arrival_time")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="报关完成时间" align="center"  :key="43" v-if="customizeShowColumns.declaration">
          <el-table-column label="时间(外)" width="160" :key="44"  v-if="customizeShowColumns.declaration">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"customs_declaration_enddate")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160"  :key="45" v-if="customizeShowColumns.declaration">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_customs_declaration_enddate")}}
            </template>
          </el-table-column>
          <el-table-column label="报关行" :key="46"  v-if="customizeShowColumns.declaration">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"customs_declaration_customs")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="清关完成时间" align="center"  :key="47" v-if="customizeShowColumns.clearance">
          <el-table-column label="时间(外)" width="160"  :key="48" v-if="customizeShowColumns.clearance">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"customs_clearance_enddate")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160"  :key="49" v-if="customizeShowColumns.clearance">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_customs_clearance_enddate")}}
            </template>
          </el-table-column>
          <el-table-column label="清关行" :key="50"  v-if="customizeShowColumns.clearance">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"customs_clearance_customs")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="送仓时间"  align="center" :key="51"  v-if="customizeShowColumns.songcang">
          <el-table-column label="时间(外)" width="160" :key="52"  v-if="customizeShowColumns.songcang">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"delivery_time_to_warehouse")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160" :key="53"   v-if="customizeShowColumns.songcang">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_delivery_time_to_warehouse")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="分货完成时间"  align="center" :key="54"  v-if="customizeShowColumns.completion">
          <el-table-column label="时间(外)" width="160"  :key="55" v-if="customizeShowColumns.completion">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"completion_time_of_the_goods")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160" :key="56"  v-if="customizeShowColumns.completion">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_completion_time_of_the_goods")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="通知查验日期" align="center" :key="57"  v-if="customizeShowColumns.noticeInspection">
          <el-table-column label="时间(外)" width="160" :key="58"  v-if="customizeShowColumns.noticeInspection">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"notice_of_the_date_of_inspection")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160" :key="59"  v-if="customizeShowColumns.noticeInspection">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_notice_of_the_date_of_inspection")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="放行日期" align="center" :key="60"  v-if="customizeShowColumns.release">
          <el-table-column label="时间(外)" width="160"  :key="61" v-if="customizeShowColumns.release">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"release_date")}}
            </template>
          </el-table-column>
          <el-table-column label="时间(内)" width="160"  :key="62" v-if="customizeShowColumns.release">
            <template slot-scope="scope">
              {{showBatchAttribute(scope.row,"inner_release_date")}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="是否查验" width="80" :key="63"  v-if="customizeShowColumns.inspection">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"whether_the_inspection")}}</span>
          </template>
        </el-table-column>
        <el-table-column width="160" label="末端派送时间" :key="64"  v-if="customizeShowColumns.extractionTime">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"extraction_time")}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderPrescription" label="时效" :key="65"  v-if="customizeShowColumns.orderPrescription"></el-table-column>
        <el-table-column label="备注"   v-if="customizeShowColumns.remarks">
          <template slot-scope="scope">
            <span>{{scope.row.remarks}}</span>
          </template>
        </el-table-column>
        <el-table-column label="查验费收取(¥)"  :key="66" v-if="customizeShowColumns.inspectionFee">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"inspection_fee_charged")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="查验费单" :key="67"  v-if="customizeShowColumns.inspectionBill">
          <template slot-scope="scope">
            <el-button size="small" plain v-show="showBatchAttribute(scope.row,'inspection_bill')!=''" type="primary" @click="getDownloadUrl(showBatchAttribute(scope.row,'inspection_bill'))">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column label="费用凭证" :key="68"  v-if="customizeShowColumns.customsFeeList">
          <template slot-scope="scope">
            <el-button size="small" plain v-show="showBatchAttribute(scope.row,'customs_fee_list')!=''" type="primary" @click="getDownloadUrl(showBatchAttribute(scope.row,'customs_fee_list'))">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column label="查验通知" :key="69"  v-if="customizeShowColumns.inspectionNotice">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"inspection_notice")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="承运商" :key="70"  v-if="customizeShowColumns.carriers">
          <template slot-scope="scope">
            <span>{{showBatchAttribute(scope.row,"carriers")}}</span>
          </template>
        </el-table-column>
        <el-table-column label="批次费用完成" :key="71"  v-if="customizeShowColumns.costDone">
          <template slot-scope="scope">
            <span>{{scope.row.costDone ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否购买保险" :key="72"  v-if="customizeShowColumns.purchaseInsurance">
          <template slot-scope="scope">
            <span>{{scope.row.purchaseInsurance ? '是' : '否'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-dropdown trigger="click">
              <el-button plain size="small">...</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="in_configs(40719) && !scope.row.check && conditions.isDone=='未完成'" size="mini" type="text" @click.native="handleEdit(scope.row)">
                  编辑批次
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(40720)" size="mini" type="text" @click.native="showDetail(scope.row)">
                  查看批次详情
                </el-dropdown-item>
                <el-dropdown-item v-if="in_configs(40729)" size="mini" type="text" @click.native="calculationCharge(scope.row)">
                  计费
                </el-dropdown-item>
                <el-dropdown-item v-if="!scope.row.costDone" size="mini" type="text" @click.native="costDone(scope.row)">
                  批次费用完成
                </el-dropdown-item>
                <span v-if="!scope.row.calculateCharge">
                  <el-dropdown-item v-if="in_configs(40728) && conditions.isDone=='未完成'" size="mini" type="text" @click.native="addOrderToBatch(scope.row)">
                    添加订单
                  </el-dropdown-item>
                  <el-dropdown-item v-if="in_configs(40726)" size="mini" type="text" @click.native="delfinishBelBatch(scope.row)">
                    删除批次
                  </el-dropdown-item>
                </span>
                <el-dropdown-item v-if="in_configs(40721) && conditions.isDone=='未完成'" size="mini" type="text" @click.native="batchDone(scope.row)">
                  结束批次
                </el-dropdown-item>

                <el-dropdown-item size="mini" type="text" @click.native="showLmOrderIds(scope.row)">
                    打单系统订单号
                </el-dropdown-item>

                <el-dropdown-item size="mini" type="text" @click.native="buyInsurance(scope.row)" v-if="scope.row.purchaseInsurance==false">
                    购买保险
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="conditions.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="conditions.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>

      <!-- 批次购买保险弹框 -->
      <el-dialog title="批次购买保险订单筛选" :visible.sync="insuranceOrderVisible" width="500px" >
        <el-table ref="multipleTable" :data="batchOrders" stripe tooltip-effect="dark" style="width: 100%" @selection-change="handleOrderSelectionChangeForInsurance">
          <el-table-column type="selection" width="55"></el-table-column>
          <!-- <el-table-column prop="orderId" label="订单号"></el-table-column> -->
          <el-table-column label="订单号">
              <template slot-scope="scope">
                  {{scope.row}}
              </template>
          </el-table-column>         
        </el-table>
        <!-- <el-pagination background @size-change="handleBatchSizeChange" @current-change="handleBatchCurrentChange" :current-page="batchCurrentPage" :page-sizes="batchPageSizes" :page-size="batchPageSize" layout="total, sizes, prev, pager, next, jumper" :total="batchTotal">
        </el-pagination>         -->

        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="insuranceOrderVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="buyInsuranceSubmit()">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 批次详情 -->
      <el-dialog title="批次详情" :visible.sync="dialogTableVisible">
        <el-form :model="batchDetail" size="small" inline>
          <el-form-item label="批次号" label-width="70px">{{batchDetail.batchId}}</el-form-item>
          <el-form-item label="状态" label-width="70px">{{batchDetail.statusName}}</el-form-item>
        </el-form>
        <el-table :data="batchDetail.order">
          <el-table-column type="expand">
            <template slot-scope="props">
              <table class="table" border="1">
                <thead>
                  <tr>
                    <th>货箱编号</th>
                    <th>重量(kg)</th>
                    <th>体积(m³)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(data, index) in props.row.cartons" :key="index">
                    <td>{{data.cartonNumber}}</td>
                    <td>{{data.weight}}</td>
                    <td>{{data.volume}}</td>
                  </tr>
                </tbody>
              </table>
            </template>
          </el-table-column>
          <el-table-column property="customer" label="客户"></el-table-column>
          <el-table-column property="orderId" label="订单号"></el-table-column>
          <el-table-column label="一般贸易">
            <template slot-scope="scope">
              {{scope.row.generalTrade?"是":"否"}}
            </template>
          </el-table-column>
          <el-table-column property="qty" label="箱数"></el-table-column>
          <el-table-column property="typeName" label="类型"></el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <el-input size="small" :disabled="conditions.isDone!='未完成'" v-model.lazy="scope.row.remark"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" v-show="conditions.isDone=='未完成'" class="btn-cyan" @click="saveRemark(scope.row)">保存</el-button>
              <i class="el-icon-delete" v-show="in_configs(40725)" @click="finishBatchOrderDel(batchDetail.batchId, scope.row.orderId)"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog title="批次详情" :visible.sync="tableVisible" append-to-body width="30%">
          <el-form :model="cartonList" size="small" inline>
            <el-form-item label="订单号" label-width="70px">{{cartonList.orderId}}</el-form-item>
            <el-form-item label="货物箱数" label-width="70px">{{cartonList.qty}}</el-form-item>
          </el-form>
          <el-table :data="cartonList.cartons">
            <el-table-column property="cartonNumber" label="货箱编号"></el-table-column>
            <el-table-column property="weight" label="重量(kg)"></el-table-column>
            <el-table-column property="volume" label="体积(㎡)"></el-table-column>
          </el-table>
        </el-dialog>
      </el-dialog>
      <!-- 出货 -->
      <el-dialog title="出货" :visible.sync="clearVisible">
        <el-form :model="batchDetail" size="small">
          <el-form-item label="批次号" :label-width="formLabelWidth">{{batchDetail.batchId}}</el-form-item>
          <el-form-item label="柜/板号" :label-width="formLabelWidth">{{batchDetail.containerNumber}}</el-form-item>
          <el-form-item label="出货箱数" :label-width="formLabelWidth">{{batchDetail.qty}}</el-form-item>
          <el-form-item label="运送车辆" :label-width="formLabelWidth">
            <p v-for="(d, i) in shipmentValue" :key="i" style="margin-bottom: 10px;">
              <el-select v-model.lazy="d.vehicle" class="form-inline" @change="showChangeShipment">
                <el-option v-for="(d,i) in vehicleData" :key="i" :label="d.licensePlate" :value="d.id"></el-option>
              </el-select>
              <el-select v-model.lazy="d.driver" multiple>
                <el-option v-for="(d,i) in driverData" :key="i" :label="d.name" :value="d.id"></el-option>
              </el-select>
              <i v-show="i > 0" class="el-icon-delete" @click="carDelete(i, d, shipmentValue)"></i>
            </p>
            <i class="el-icon-circle-plus-outline" @click="handleAdd(shipmentValue)"></i>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="clearVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="changeShipment">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 报关 -->
      <el-dialog title="报关" :visible.sync="clearanceVisible" width="40%">
        <el-form :model="customsDeclarationForm" size="small" :rules="customsDeclarationFormRules" ref="customsDeclarationFormRef">
          <el-form-item label="批次号" :label-width="formLabelWidth">{{customsDeclarationForm.batchId}}</el-form-item>
          <el-form-item label="柜/板号" :label-width="formLabelWidth">{{customsDeclarationForm.containerNumber}}</el-form-item>
          <el-form-item label="出货箱数" :label-width="formLabelWidth">{{customsDeclarationForm.qty}}</el-form-item>
          <el-form-item label="开始时间" :label-width="formLabelWidth" prop="customsDeclarationStartDate">
            <el-date-picker v-model.lazy="customsDeclarationForm.customsDeclarationStartDate" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            <el-button size="small" class="btn-cyan" @click="customsDeclarationSetStartDate('CUSTOMS_BROKER')">开始报关</el-button>
          </el-form-item>
          <el-form-item label="结束时间" :label-width="formLabelWidth" prop="customsDeclarationEndDate">
            <el-date-picker v-model.lazy="customsDeclarationForm.customsDeclarationEndDate" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="报关行" :label-width="formLabelWidth" prop="customsDeclarationId">
            <el-select v-model.lazy="customsDeclarationForm.customsDeclarationId">
              <el-option v-for="(d,i) in customsDeclarationList" :key="i" :label="d.customsName" :value="d.customsId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报关状态" :label-width="formLabelWidth" prop="customsDeclarationStatus">
            <el-select v-model.lazy="customsDeclarationForm.customsDeclarationStatus">
              <el-option label="报关完成" value="done"></el-option>
              <el-option label="报关异常" value="exception"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="clearanceVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="customsDeclaration('CUSTOMS_BROKER')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 出发 -->
      <el-dialog title="出发" :visible.sync="departVisible" width="40%">
        <el-form :model="departureForm" size="small" :rules="departureFormRules" ref="departureFormRef">
          <el-form-item label="批次号" :label-width="formLabelWidth">{{departureForm.batchId}}</el-form-item>
          <el-form-item label="柜/板号" :label-width="formLabelWidth">{{departureForm.containerNumber}}</el-form-item>
          <el-form-item label="出货箱数" :label-width="formLabelWidth">{{departureForm.qty}}</el-form-item>
          <el-form-item label="出货时间" :label-width="formLabelWidth" prop="date">
            <el-date-picker v-model.lazy="departureForm.date" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="航班号" :label-width="formLabelWidth" prop="number">
            <el-input v-model.lazy="departureForm.number" placeholder="号"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="departVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="departure">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 箱数点击详情 -->
        <el-dialog title="轨迹详情" :visible.sync="countisShow" width="60%" @close="closedialog" :close-on-click-modal="false">
            <el-form  size="small"  >
              <el-form-item label="状态" style="margin-left:15px">
              <el-select @change="chouseStatus" v-model="chouseValue" :clearable="true">
                <el-option label="全部" value="全部"></el-option>
                <el-option label="已签收" value="已签收"></el-option>
                <el-option label="已提取" value="已提取"></el-option>
                <el-option label="未提取" value="未提取"></el-option>      
              </el-select>
            </el-form-item>
               <el-form-item label="跟踪号">
                  <el-input placeholder="跟踪号" v-model="tableSearch" style="width:200px" :clearable="true"></el-input>
                  <el-button size="mini" type="primary" @click="handleSearch" style="margin-left:20px">查询</el-button>
                  <el-button size="mini" type="primary" @click="exportTracking(1)" style="margin-left:20px">导出</el-button>
                  <el-button size="mini" type="primary" @click="exportTracking(2)" style="margin-left:20px">导出提取时间统计</el-button>
                  <el-button size="mini" type="primary" @click="exportTracking(3)" style="margin-left:20px">导出派送时间统计</el-button>
            </el-form-item>
            </el-form>
            <el-table :data="savebatchList" border ref="cpbatchtable" height="400px" v-el-table-infinite-scroll="load">
              <el-table-column  label="订单号" align="center">
                <template slot-scope="scope">
                   <span>{{scope.row.orderId}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="邮编" align="center">
                <template slot-scope="scope">
                   <span>{{scope.row.postcode}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="轨迹跟踪号" align="center">
                <template slot-scope="scope">
                   <span>{{scope.row.trackingNumber}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="状态"  align="center" >
                <template slot-scope="scope">
                   <span>{{columnshow(scope.row.delivered,scope.row.pickedUp)}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="提取时间" align="center">
                <template slot-scope="scope">
                   <span>{{showTimer(scope.row.pickedUpAt)}}</span>
                </template>
              </el-table-column>
              <el-table-column  label="签收时间" align="center">
                <template slot-scope="scope" v-if="scope.row.delivered">
                   <span>{{showTimertwo(scope.row.deliveredAt,scope.row.delivered)}}</span>
                </template>
              </el-table-column>
            </el-table>
                   <!-- <el-pagination
                            @size-change="handleSizeChangetwo"
                            @current-change="handleCurrentChangetwo"
                            :current-page="currentPagetwo"
                            :page-sizes="[5, 10, 20, 40]" 
                            :page-size="pagesizetwo"        
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="savebatchList.length">   
                    </el-pagination> -->
      </el-dialog>
      <!-- 到达 -->
      <el-dialog title="到达" :visible.sync="toVisible" width="40%">
        <el-form :model="arrivalForm" size="small" :rules="arrivalFormRules" ref="arrivalFormRef">
          <el-form-item label="批次号" :label-width="formLabelWidth">{{arrivalForm.batchId}}</el-form-item>
          <el-form-item label="柜/板号" :label-width="formLabelWidth">{{arrivalForm.containerNumber}}</el-form-item>
          <el-form-item label="出货箱数" :label-width="formLabelWidth">{{arrivalForm.qty}}</el-form-item>
          <el-form-item label="到达时间" :label-width="formLabelWidth" prop="date">
            <el-date-picker v-model.lazy="arrivalForm.date" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="toVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="arrival">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 清关 -->
      <el-dialog title="清关" :visible.sync="customsVisible" width="40%">
        <el-form :model="customsDeclarationForm" size="small" :rules="customsDeclarationFormRules" ref="customsDeclarationFormRef">
          <el-form-item label="批次号" :label-width="formLabelWidth">{{customsDeclarationForm.batchId}}</el-form-item>
          <el-form-item label="柜/板号" :label-width="formLabelWidth">{{customsDeclarationForm.containerNumber}}</el-form-item>
          <el-form-item label="出货箱数" :label-width="formLabelWidth">{{customsDeclarationForm.qty}}</el-form-item>
          <el-form-item label="开始时间" :label-width="formLabelWidth" prop="customsDeclarationStartDate">
            <el-date-picker v-model.lazy="customsDeclarationForm.customsDeclarationStartDate" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            <el-button size="small" class="btn-cyan" @click="customsDeclarationSetStartDate('BROKER')">开始清关</el-button>
          </el-form-item>
          <el-form-item label="结束时间" :label-width="formLabelWidth" prop="customsDeclarationEndDate">
            <el-date-picker v-model.lazy="customsDeclarationForm.customsDeclarationEndDate" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
          <el-form-item label="清关行" :label-width="formLabelWidth" prop="customsDeclarationId">
            <el-select v-model.lazy="customsDeclarationForm.customsDeclarationId">
              <el-option v-for="(d,i) in customsDeclarationList" :key="i" :label="d.customsName" :value="d.customsId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="清关状态" :label-width="formLabelWidth" prop="customsDeclarationStatus">
            <el-select v-model.lazy="customsDeclarationForm.customsDeclarationStatus">
              <el-option label="清关完成" value="done"></el-option>
              <el-option label="清关异常" value="exception"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="customsVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="customsDeclaration('BROKER')">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 入海外仓 -->
      <el-dialog title="入海外仓" :visible.sync="werehouseVisible" width="40%">
        <el-form :model="inOverseasWarehouseForm" size="small" :rules="inOverseasWarehouseFormRules" ref="inOverseasWarehouseFormRef">
          <el-form-item label="批次号" :label-width="formLabelWidth">{{inOverseasWarehouseForm.batchId}}</el-form-item>
          <el-form-item label="柜/板号" :label-width="formLabelWidth">{{inOverseasWarehouseForm.containerNumber}}</el-form-item>
          <el-form-item label="入仓箱数" :label-width="formLabelWidth" prop="number">
            <el-input v-model.lazy="inOverseasWarehouseForm.number" placeholder="入仓箱数" type="number"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="werehouseVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="inOverseasWarehouse">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 编辑--弹层 -->
      <el-dialog title="编辑" class="batch-operation__dialog" :visible.sync="dialogEditVisible">
        <el-form class="edit-form" :model="editForm" label-width="120px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="批次号">{{editForm.id}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="箱数">{{editForm.qty}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="毛重(kg)">{{editForm.weight?toFixed(editForm.weight,3):""}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="体积(cbm)">{{editForm.volume?toFixed(editForm.volume,6):""}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="时效">{{editForm.orderPrescription}}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="是否查验">
                <el-switch v-model.lazy="editForm.batchAttribute.whether_the_inspection"></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editForm.channelType === 'AIR_SHIPPING'">
              <el-form-item label="航空公司">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.airlines"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editForm.channelType === 'SEA_SHIPPING'">
              <el-form-item label="船公司">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.shipping_company"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editForm.channelType === 'RAILWAY_SHIPPING'">
              <el-form-item label="铁路公司">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.railway_companies"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代理公司">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.agency_company"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editForm.channelType !== 'SEA_SHIPPING'">
              <el-form-item label="航空单号">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.air_waybill"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="editForm.channelType === 'SEA_SHIPPING'">
              <el-form-item label="柜号">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.air_waybill"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提单重">
                <el-input size="small" type="number" v-model.lazy="editForm.batchAttribute.bill_of_lading_weight"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="计费重">
                <el-input size="small" type="number" v-model.lazy="editForm.batchAttribute.billing_weight"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="末端派送时间">
                <el-date-picker size="small" v-model.lazy="editForm.batchAttribute.extraction_time" type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="承运商">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.carriers"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="查验费收取(¥)">
                <el-input size="small" type="number" v-model.lazy="editForm.batchAttribute.inspection_fee_charged"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="查验通知">
                <el-input size="small" v-model.lazy="editForm.batchAttribute.inspection_notice"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="出货">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.delivery_time" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">运送车辆</span>
                    <el-select class="width-inline" v-model.lazy="editForm.batchAttribute.transport_vehicles" size="small" filterable multiple clearable placeholder="请选择运送车辆">
                      <el-option style="width: 100%;" v-for="(d,i) in vehicleData" :key="i" :label="d.licensePlate" :value="d.id">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_delivery_time" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">司机</span>
                    <el-select class="width-inline" v-model.lazy="editForm.batchAttribute.transport_drivers" size="small" filterable multiple clearable placeholder="请选择司机">
                      <el-option v-for="(d,i) in driverData" :key="i" :label="d.name" :value="d.id">
                      </el-option>
                    </el-select>
                  </el-col>

                  <el-col :span="12">
                        <span class="sub-label">出货备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.delivery_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="入监管仓时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.time_in_custody" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_time_in_custody" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label" style="width:80px;" >入监管仓备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.in_custody_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="editForm.channelType === 'AIR_SHIPPING'">
              <el-form-item label="起飞时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.departure_time" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_departure_time" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label">起飞备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.departure_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="editForm.channelType === 'AIR_SHIPPING'">
              <el-form-item label="落地时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.landing_time" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_landing_time" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label">落地备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.landing_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="editForm.channelType === 'SEA_SHIPPING'">
              <el-form-item label="开船时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.sailing_time" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_sailing_time" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label">开船备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.sailing_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="editForm.channelType === 'SEA_SHIPPING'">
              <el-form-item label="到港时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.port_time" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_port_time" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label">到港备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.port_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="editForm.channelType === 'RAILWAY_SHIPPING'">
              <el-form-item label="开车时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.driving_time" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_driving_time" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label">开车备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.driving_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="editForm.channelType === 'RAILWAY_SHIPPING'">
              <el-form-item label="到达时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.arrival_time" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_arrival_time" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label">到达备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.arrival_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="报关完成时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.customs_declaration_enddate" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">报关行</span>
                    <el-select class="width-inline" size="small" placeholder="选择报关行" filterable clearable v-model.lazy="editForm.batchAttribute.customs_declaration_customs">
                      <el-option v-for="(d,i) in customsDeclarationList" :key="i" :label="d.customsName" :value="d.customsId"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_customs_declaration_enddate" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label" style="width:80px;">报关完成备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.customs_declaration_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="清关完成时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.customs_clearance_enddate" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">清关行</span>
                    <el-select class="width-inline" size="small" placeholder="选择清关行" filterable clearable v-model.lazy="editForm.batchAttribute.customs_clearance_customs">
                      <el-option v-for="(d,i) in customsDeclarationList2" :key="i" :label="d.customsName" :value="d.customsId"></el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_customs_clearance_enddate" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label" style="width:80px;">清关完成备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.customs_clearance_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="送仓时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.delivery_time_to_warehouse" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_delivery_time_to_warehouse" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label">送仓备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.delivery_time_to_warehouse_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="分货完成时间">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.completion_time_of_the_goods" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_completion_time_of_the_goods" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label" style="width:80px;">分货完成备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.completion_time_of_the_goods_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="通知查验日期">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.notice_of_the_date_of_inspection" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_notice_of_the_date_of_inspection" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label" style="width:80px;">通知查验备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.notice_of_the_date_of_inspection_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="放行日期">
                <el-row>
                  <el-col :span="12">
                    <span class="sub-label">计划时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.release_date" type="datetime" placeholder="计划时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                    <span class="sub-label">实际时间</span>
                    <el-date-picker class="width-inline" size="small" v-model.lazy="editForm.batchAttribute.inner_release_date" type="datetime" placeholder="实际时间" value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                  </el-col>
                  <el-col :span="12">
                        <span class="sub-label">放行备注</span>
                        <el-input size="small" type="text"  v-model.lazy="editForm.batchAttribute.release_remark"  class="width-inline" ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input size="small" type="textarea" :rows="2" v-model.lazy="editForm.remarks"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="查验单">
                <el-upload class="upload-demo" :on-change="uploadFileInspectionBill" :action="getFileUrl(editForm,'inspection_bill')" :auto-upload="false" :file-list="fileListI">
                  <el-button size="small">上传</el-button>
                </el-upload>
                <el-button size="small" v-show="true" type="primary" plain @click="getDownloadUrl('inspection_bill')">下载</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="费用凭证">
                <el-upload class="upload-demo" :on-change="uploadFileCustomsFeeList" action="#" :auto-upload="false" :file-list="fileListC">
                  <el-button size="small">上传</el-button>
                </el-upload>
                <div v-for='(item,index) in customsFeeList' :key="index">
               <!--  <el-button size="small" v-show="true" type="primary" plain @click="getDownloadUrl('customs_fee_list')">下载</el-button> -->
                费用凭证 {{index+1}} <el-button size="small" type="primary" plain @click="getCustomsDownloadUrl(item)">下载 </el-button>
                <el-button size="small" type="primary" plain @click="deleteFile(index,item,editForm.id,'customs_fee_list')">删除 </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogEditVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="handleSave">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加订单" :visible.sync="addOrderTobatchDialog" width="80%">
        <el-form :model="batchUsableTransportCapacityValue" size="small" inline>
          <el-form-item label="运力名称:" label-width="75px"><b>{{batchUsableTransportCapacityValue.name}}</b></el-form-item>
          <el-form-item label="渠道:" label-width="60px"><b>{{channelTypeMaps[batchUsableTransportCapacityValue.channelType]}}</b></el-form-item>
          <el-form-item label="剩余重量(Kg):" label-width="110px"><b>{{batchUsableTransportCapacityValue.weightLimit}}</b></el-form-item>
          <el-form-item label="剩余体积(cbm):" label-width="110px"><b>{{batchUsableTransportCapacityValue.volumeLimit}}</b></el-form-item>
        </el-form>
        <div class="selected-cartons">
          <div>当前已选货物重量：<b>{{currentTotalWeight}}</b>&nbsp;kg，</div>
          <div>体积：<b>{{currentTotalVolume}}</b>&nbsp;cbm</div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancelAddOrderToBatch()">取 消</el-button>
          <el-button size="small" type="primary" @click="saveAddOrderToBatch()">确 定</el-button>
        </div>
        <el-form :inline="true" :model="addOrderQueryForm" class="add-order__form" size="small">
          <el-form-item label="选择渠道">
            <el-select v-model="addOrderQueryForm.productIds" filterable clearable multiple placeholder="选择渠道" style="width: 300px;">
              <el-option v-for="(d, i) in channels" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单号">
            <el-input type="textarea" v-model="addOrderQueryOrderIds" placeholder="多个订单号用回车分割" style="width: 300px;"></el-input>
          </el-form-item>
          <el-button type="primary" style="margin-left: 30px;" size="small" @click="queryAddBatchOrderTask()">搜索</el-button>
        </el-form>
        <el-table ref="multipleTable" :data="penddingTableData" stripe tooltip-effect="dark" style="width: 100%" @selection-change="handleOrderSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="orderId" label="订单号"></el-table-column>
          
          <el-table-column label="仓库">
              <template slot-scope="scope">
                  {{warehouseMap[scope.row.warehouseCode]}}
              </template>
          </el-table-column>
          <el-table-column label="客户">
            <template slot-scope="scope">
              {{customerMaps[scope.row.orgOwner]}}
            </template>
          </el-table-column>
          <el-table-column label="客户类型">
            <template slot-scope="scope">
              {{customerTypeMap[scope.row.orgOwnerType]}}
            </template>
          </el-table-column>
          <el-table-column label="渠道">
            <template slot-scope="scope">
              {{channelsMaps[scope.row.procutId]}}
            </template>
          </el-table-column>
          <el-table-column label="一般贸易">
            <template slot-scope="scope">
              {{scope.row.generalTrade?"是":"否"}}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="refNumber" label="客户单号"></el-table-column> -->
          <el-table-column prop="totalCarton" label="箱数"></el-table-column>
          <el-table-column prop="totalVolume" label="总体积(cbm)">
            <template slot-scope="scope">
              {{toFixed(scope.row.totalVolume/1000000,6)}}
            </template>
          </el-table-column>
          <el-table-column prop="totalWeight" label="总重量(kg)"></el-table-column>
          <el-table-column prop="volumeWeight" label="体积重"></el-table-column>
          <el-table-column prop="createAt" label="时间">
            <template slot-scope="scope">
              {{ formateDate(scope.row.createAt)}}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @size-change="handleBatchSizeChange" @current-change="handleBatchCurrentChange" :current-page="batchCurrentPage" :page-sizes="batchPageSizes" :page-size="batchPageSize" layout="total, sizes, prev, pager, next, jumper" :total="batchTotal">
        </el-pagination>
      </el-dialog>

      <el-dialog title="选择供应商渠道" :visible.sync="dialogSupplierChannelVisible" width="1250px">
        <el-table :data="supplierChannelData" style="width: 100%" class="add-file__table">
          <el-table-column label="服务类型" width="180">
            <template slot-scope="scope">
              <el-select v-model="scope.row.serviceTypeId" @change="getSupplierChannel(scope.row)" size="small">
                <el-option v-for="(item, index) in serviceTypes" :key="index" :label="item.name" :value="item.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="供应商渠道" width="180">
            <template slot-scope="scope">
              <el-select v-model="scope.row.supplierChannelId" @change="getSupplierChannelPrice(scope.row)" clearable size="small">
                <el-option v-for="(item, index) in scope.row.supplierChannelList" :key="index" :label="item.code" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="计费方式">
            <template slot-scope="scope">
              <span v-if="!scope.row.isEdit">{{calculationMethodMap[scope.row.calculationMethod]}}</span>
              <el-select v-if="scope.row.isEdit" v-model="scope.row.calculationMethod" clearable size="small">
                <el-option v-for="(item, index) in calculationMethods" :key="index" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="价格">
            <template slot-scope="scope">
              <span v-if="!scope.row.isEdit">{{scope.row.price}}</span>
              <el-input v-if="scope.row.isEdit" type="number" min="0" size="small" v-model="scope.row.price" auto-complete="off"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="分摊类型"  width="180">
            <template slot-scope="scope">
              <el-select  size="small" v-model="scope.row.shareType" @change="chouseType" clearable>
                <el-option v-for="(d, i) in shareTypeData" :key="i" :label="d.name" :value="d.code"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="上传图片" prop="img" >
            <template slot-scope="scope">
                   <el-upload 
                   style="width:100px;" 
                  v-if="scope.row.isEdit"
                  ref="upload"
                  action="#"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit='limitCount'
                  :auto-upload="false"
                  :on-change="handleChange"
                  :on-exceed="handleExceed"
                  :before-upload="handleBeforeUpload"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :class="{ disabled: uploadDisabled }">
                  <i class="el-icon-plus"></i>
                </el-upload>
            </template>
          </el-table-column>

          <el-table-column label="备注">
            <template slot-scope="scope">
              <!-- <span v-if="!scope.row.isEdit">{{scope.row.remarks}}</span> -->
              <el-input type="textarea" v-model.lazy="scope.row.remarks" placeholder="备注" :rows="4" auto-complete="off"></el-input>

            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button v-if="scope.row.isEdit" type="text" size="mini" @click="saveSupplierChannelPrice(scope.row, true)">保存</el-button>
              <el-button v-if="scope.row.isEdit" type="text" size="mini" @click="saveSupplierChannelPrice(scope.row, false)">取消</el-button>
              <a class="el-icon-edit-outline" v-if="!scope.row.isEdit" href="#" @click.prevent="editSupplierChannel(scope.row)" title="编辑"></a>
              <a class="el-icon-circle-plus-outline" href="#" @click.prevent="addRow(scope.$index)" title="添加"></a>
              <a class="el-icon-delete" href="#" v-if="supplierChannelData.length != 1" @click.prevent="removeRow(scope.$index)" title="删除"></a>
            </template>
          </el-table-column>
        </el-table>
        <span v-if="batchCostPriceData && batchCostPriceData.length != 0">
          <h3 style="margin:20px 0 10px 0">已添加费用</h3>
          <el-table :data="batchCostPriceData" style="width: 100%" class="add-file__table">
            <el-table-column label="服务类型" width="180">
              <template slot-scope="scope">{{scope.row.serviceType}}</template>
            </el-table-column>
            <el-table-column label="供应商渠道" width="180">
              <template slot-scope="scope">{{scope.row.supplierChannel}}</template>
            </el-table-column>
            <el-table-column label="计费方式">
              <template slot-scope="scope">{{calculationMethodMap[scope.row.calculationMethod]}}</template>
            </el-table-column>
            <el-table-column label="价格">
              <template slot-scope="scope">{{scope.row.price}}</template>
            </el-table-column>
            <el-table-column label="备注">
              <template slot-scope="scope">{{scope.row.remarks}}</template>
            </el-table-column>
            <el-table-column label="操作人">
              <template slot-scope="scope">{{scope.row.operator}}</template>
            </el-table-column>
          </el-table>
        </span>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogSupplierChannelVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="calculationBatchCostCharge">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="选择导出日期" :visible.sync="batchDetailDialogVisible" width="400px">
        <el-form :inline="true" class="header-search__form" size="small" label-width="90px">
          <el-form-item label="开始日期">
            <el-date-picker v-model.lazy="downloadBatchDetailStartDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model.lazy="downloadBatchDetailEndDate" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束日期"></el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="batchDetailDialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="downloadBatchDetail">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 导出子单签收时间dialog -->
       <el-dialog title="选择导出日期" :visible.sync="sonOrderSingOutdialog" width="400px">
        <el-form :inline="true" class="header-search__form" size="small" label-width="90px">
          <el-form-item label="开始日期">
            <el-date-picker v-model.lazy="begintime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model.lazy="endtime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束日期"></el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="sonOrderSingOutdialog = false">取 消</el-button>
          <el-button size="small" type="primary" @click="downloadsonOrderSingOut">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>

    <!-- 自定义列表展示项 -->
		<customize-colums
      width = "800px"
			:tablename = "tablename"
			:customizeDialogVisible = "customizeDialogVisible"
			:customizeShowColumns = "customizeShowColumns"
			@selectedColumns = "selectedColumns"
			@closeCustomizeDialog = "closeCustomizeDialog">
		</customize-colums>
  </div>
</template>

<script>
// import { base64ToUint8Array, dateFormat } from '@/util/index.js'
import customizeColums from "../../components/customize-columns.vue";
import { mapState, mapMutations } from "vuex";
import {shareType,getTrackList} from '@/util/batchAPI'
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'

function clone(obj) {
  if (!obj || typeof obj != "object") return obj;
  let _newObj = new Object();
  for (let key in obj) {
    _newObj[key] = clone(obj[key]);
  }
  return _newObj;
}
export default {
  data() {
     const list = []
    for (let i = 0; i < 20; i++) {
      list.push('item' + (i + 1))

    }
    return {
      insuranceOrderSelection: [],
      insuranceOrderVisible: false,
      batchOrders: [],
      begintime:'', //导出子单签收时间
      endtime:'', //导出子单签收时间
      sonOrderSingOutdialog:false, //子单导出时间弹窗
      countisShow:false,//箱数详情弹窗是否显示
      savebatchList:this.$store.state.savebatchList, // 箱数详情列表
      shareTypeData: [],//分摊类型数据
      tableSearch:'', //模糊查询
      currentPage1: 5,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 4,
      list:[],
      limit:5,
      currentPagetwo:1,
      pagesizetwo:10,
      page:1,
      qshow:true,
      tiqushow:true,
      chouseValue:'',
      limitCount:1,
      uploadDisabled:false,//上传按钮是否显示
      batchId: "",
      dialogSupplierChannelVisible: false,
      supplierChannelData: [
        {
          supplierChannels: [],
          supplierChannelList: [],
          serviceTypeId: "",
          supplierChannelId: "",
          calculationMethod: "",
          price: "",
          isEdit: false,
          shareType:'',
          remarks: ''
        }
      ],
      batchCostPriceData: [],
      serviceTypes: [],
      serviceTypeMap: {},
      supplierChannels: [],
      supplierChannelList: [],
      calculationMethods: [
        {
          value: "CONSTANT",
          name: "固定费用"
        },
        {
          value: "WEIGHT_UNIT_PRICE",
          name: "重量*单价"
        },
        {
          value: "VOLUME_UNIT_PRICE",
          name: "体积*单价"
        }
      ],
      calculationMethodMap: {
        CONSTANT: "固定费用",
        WEIGHT_UNIT_PRICE: "重量*单价",
        VOLUME_UNIT_PRICE: "体积*单价"
      },
      isEditSupplierChannelPrice: false,
      batchTypeList: [
        {
          id: "selfsupport",
          name: "自营"
        },
        {
          id: "agency",
          name: "代理"
        }
      ],
      batchTypeMap: {
        selfsupport: "自营",
        agency: "代理"
      },
      channelTypeMaps: {
        SEA_SHIPPING: "海运",
        AIR_SHIPPING: "空运",
        RAILWAY_SHIPPING: "铁运"
      },
      customerTypeMap: {
        NORMAL: "普通客户",
        ONLINE_SELF_EMPLOYED: "线上自营",
        OFFLINE_SELF_EMPLOYED: "线下自营",
        ONLINE_AGENCY: "线上代理",
        OFFLINE_AGENCY: "线下代理"
      },
      loading: true,
      isSearchMore: false,
      customizeDialogVisible: false,
      customizeShowColumns: {
        id: true,
        airlines: true,
        shippingCompany: true,
        railwayCompany: true,
        airBill: true,
        guihao: true,
        agencyCompany: false,
        totalOrder: true,
        qty: true,
        weight: true,
        volume: false,
        tidanWeight: false,
        billingWeight: false,
        chuhuo: false,
        timeInCustody: false,
        declaration: false,
        clearance: false,
        departure: false,
        kaichuan: false,
        driving: false,
        landing: false,
        port: false,
        arrival: false,
        songcang: false,
        completion: false,
        inspection: false,
        noticeInspection: false,
        release: false,
        extractionTime: false,
        orderPrescription: false,
        remarks: false,
        inspectionFee: false,
        inspectionBill: false,
        customsFeeList: false,
        inspectionNotice: false,
        carriers: false,
        costDone: false,
        totalDelivered:true,
        totalPickedUp:true,
        pTime:true,
        STime:true,
        purchaseInsurance: true
      },
      isCheck: false,
      tablename: "批次操作",
      conditions: {
        status: "AIR_SHIPPING",
        isDone: "未完成",
        capacity: "",
        container: "",
        order: "",
        batchIdTextArea: "",
        startDate: "2020-01-01 01:01:01",
        endDate: "2026-01-01 01:01:01",
        // startDate: "",
        // endDate: "",
        searchTextArea: "",
        currentPage: 1,
        pageSize: 10,
        type: ""
      },
      channelType: [],
      tableData: [],
      capaticyList: [],
      gridData: [
        {
          test: "test"
        }
      ],
      form: {
        test: "666",
        value1: "",
        value2: "",
        arr: [
          {
            test: ""
          }
        ]
      },
      tableIndex: -1,
      customsFeeList: [],
      editForm: {
        id: "",
        remarks: "",
        batchAttribute: {
          container_number: "",
          delivery_time: "",
          transport_vehicles: "",
          transport_drivers: "",
          inner_delivery_time: "",
          time_in_custody: "",
          inner_time_in_custody: "",
          customs_declaration_enddate: "",
          inner_customs_declaration_enddate: "",
          departure_time: "",
          inner_departure_time: "",
          sailing_time: "",
          inner_sailing_time: "",
          driving_time: "",
          inner_driving_time: "",
          landing_time: "",
          inner_landing_time: "",
          port_time: "",
          inner_port_time: "",
          arrival_time: "",
          inner_arrival_time: "",
          customs_clearance_enddate: "",
          inner_customs_clearance_enddate: "",
          delivery_time_to_warehouse: "",
          inner_delivery_time_to_warehouse: "",
          completion_time_of_the_goods: "",
          inner_completion_time_of_the_goods: "",
          extraction_time: "",
          notice_of_the_date_of_inspection: "",
          inner_notice_of_the_date_of_inspection: "",
          release_date: "",
          inner_release_date: "",
          customs_fee_list: "",
          inspection_bill: "",
          delivery_remark: "", //节点备注
          in_custody_remark: "", //节点备注
          departure_remark: "", //节点备注
          landing_remark: "", //节点备注
          sailing_remark: "", //节点备注
          port_remark: "", //节点备注
          driving_remark: "", //节点备注
          arrival_remark: "", //节点备注
          customs_declaration_remark: "", //节点备注
          customs_clearance_remark: "", //节点备注
          delivery_time_to_warehouse_remark: "", //节点备注
          completion_time_of_the_goods_remark: "", //节点备注
          notice_of_the_date_of_inspection_remark: "", //节点备注
          release_remark: "" //节点备注
        }
      },
      fileListI: [],
      fileListC: [],
      formLabelWidth: "120px",
      needInitData: true,
      dialogEditVisible: false,
      clearVisible: false,
      clearanceVisible: false,
      departVisible: false,
      toVisible: false,
      customsVisible: false,
      werehouseVisible: false,
      dialogTableVisible: false,
      tableVisible: false,
      //====批次添加订单begin
      addOrderTobatchDialog: false,
      addOrderQueryOrderIds: "",
      batchUsableTransportCapacityValue: {},
      orderTobatchId: "",
      addOrderQueryForm: {
        productIds: [],
        orderIds: []
      },
      currentTotalWeight: 0.0,
      currentTotalVolume: 0.0,
      channels: [],
      channelsMaps: {},
      penddingTableData: [],
      batchPageSizes: [10, 20, 50, 100],
      batchPageSize: 10,
      batchTotal: 0,
      batchCurrentPage: 1, //当前页
      nomore: false,
      currentPage: 10,
      queryForm: {
        warehouseIds: [],
        customerType: [],
        orderIds: [],
        status: -1,
        customerIds: [],
        capacityIds: [],
        productIds: [],
        batchIds: [],
        startDate: "",
        endDate: "",
        export: 0
      },

      warehouses: [],
      warehouseMap: {},

      customerMaps: {},
      capcaityOrderSelection: [],
      capcaityOrderSelectionEnding: [],
      selectOrderChannelIds: [],
      //====批次添加订单end
      multipleSelection: [],
      batchDetail: {},
      vehicleData: [],
      vehicleDataCache: [],
      driverData: [],
      driverDataCache: [],
      shipmentValue: [{}],
      customsDeclarationList: [],
      customsDeclarationList2: [],
      customsDeclarationForm: {},
      customsDeclarationFormRules: {
        customsDeclarationStartDate: [
          { required: true, message: "请选择报关开始时间", trigger: "change" }
        ],
        customsDeclarationEndDate: [
          { required: true, message: "请选择报关结束时间", trigger: "change" }
        ],
        customsDeclarationId: [
          { required: true, message: "请选择报关行", trigger: "change" }
        ],
        customsDeclarationStatus: [
          { required: true, message: "请选择报关状态", trigger: "change" }
        ]
      },
      departureFormRules: {
        date: [{ required: true, message: "请选日期", trigger: "change" }],
        number: [{ required: true, message: "请输入航班号", trigger: "blur" }]
      },
      arrivalFormRules: {
        date: [{ required: true, message: "请选日期", trigger: "change" }]
      },
      inOverseasWarehouseFormRules: {
        number: [{ required: true, message: "请输入数量", trigger: "blur" }]
      },
      cartonList: {
        cartonNumber: "",
        weight: "",
        volume: ""
      },
      total: 0,
      amountOrder: 0,
      amountOrder1: 0,
      clone(obj) {
        if (!obj || typeof obj != "object") return obj;
        let _newObj = new Object();
        for (let key in obj) {
          _newObj[key] = clone(obj[key]);
        }
        return _newObj;
      },
      departureForm: {
        date: "",
        number: ""
      },
      arrivalForm: {
        date: ""
      },
      inOverseasWarehouseForm: {
        number: ""
      },
      //sahngcahun  tup
        supplierChannelPriceForm: {
        channelId: "",
        calculationMethod: "",
        price: null,
        img: "",
        shareType:''
      },
      window: window,
      batchDetailDialogVisible: false,
      downloadBatchDetailStartDate: "",
      downloadBatchDetailEndDate: ""
    };
  },
  components: {
    customizeColums
  },
  watch: {
    tableSearch(val) {
      // this.$ref.cpbatchtable.filter(val);
    }
  },
  computed: {
    ...mapState(["batchRowData"])
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === "/orderoperation/batchoperation/edit") {
      next(vm => {
        vm.needInitData = false;
        vm.conditions = JSON.parse(sessionStorage.getItem("batch_conditions"));
        vm.amountOrder = JSON.parse(
          sessionStorage.getItem("batch_amountOrder")
        );
        vm.tableData = JSON.parse(sessionStorage.getItem("batch_tableData"));
        let tableIndex = -1;
        vm.tableData.forEach((item, index) => {
          if (item.id === vm.batchRowData.id) {
            tableIndex = index;
          }
        });
        vm.tableData[tableIndex] = vm.batchRowData;
        vm.total = vm.tableData.length;
        if (sessionStorage.getItem("batch_isSearchMore") === "true") {
          vm.isSearchMore = true;
        } else if (sessionStorage.getItem("batch_isSearchMore") === "false") {
          vm.isSearchMore = false;
        }
      });
    } else {
      next();
    }
  },
  created() {

    if (this.$route.query.batchId && this.$route.query.channelType) {
      this.conditions.batchIdTextArea = this.$route.query.batchId
      this.conditions.status = this.$route.query.channelType
    }

    let customerCol = localStorage.getItem("customizeTmsOpBatchColumns")
    if (customerCol) {      
      this._initCustomizeTmsOpBatchColumns(JSON.parse(customerCol));
    }
    let _this = this;
    setTimeout(function() {
      if (_this.needInitData) {
        _this.onSubmit();
      }
      _this.loadCapaticy();
      _this.initVehicle();
      _this.initDriver();
      _this.loadCustoms("CUSTOMS_BROKER");
      _this.loadCustoms("BROKER");
      _this.initData();
      _this.loading = false;
    }, 1000);
    this.findAllShareType()
  },
  methods: {
    initData() {
      let _this = this;
      let urlArray = [
        this.findAllCustomerName(),
        this.findAllWarehouse(),
        this.findAllChannle()
      ]; // unknown # of urls (1 or more)

      this.$axios.all(urlArray).then(
        this.$axios.spread(function(customerData, warehouseData, channelData) {
          _this.initCustomerData(customerData);
          _this.initWarehouseData(warehouseData);
          _this.initChannelData(channelData);
        })
      );
    },
    //获取分摊类型数据 
      findAllShareType() {
      shareType().then((res)=>{
        this.shareTypeData=res.data;
      })
    },
    //选择分摊类型   
    chouseType (val) {
    },
    initWarehouseData(data) {
      let _this = this;
      _this.warehouses = data.data;
      _this.warehouses.forEach(a => {
        _this.warehouseMap[a.id] = a.name;
      });
    },
    initChannelData(data) {
      let _this = this;
      _this.channels = data.data;
      if (_this.channels.length > 0) {
        _this.channels.forEach(c => {
          _this.channelsMaps[c.id] = c.name;
        });
        // _this.queryForm.productIds = _this.channels[0].id;
      }
    },
    initCustomerData(data) {
      let _this = this;
      if (data.data.success) {
        _this.customers = data.data.data;
        if (_this.customers.length > 0) {
          _this.customers.forEach(c => {
            _this.customerMaps[c.id] = c.name;
          });
        }
      }
    },
    // 接收自定义列表显示项组件的数据并关闭弹层
    closeCustomizeDialog(val) {
      this.customizeDialogVisible = val;
    },
    // 接收自定义列表显示项组件的数据并赋值给customizeShowColumns对象
    selectedColumns(val) {
      this._initCustomizeTmsOpBatchColumns(val);
      this.customizeDialogVisible = false;
    },
    // 给自定义列表项的对象赋值
    _initCustomizeTmsOpBatchColumns(val) {
      for (var key in val) {
        this.customizeShowColumns[key] = val[key];
      }
    },
    //获取仓库
    findAllWarehouse() {
      return this.$request1.get(
        '/warehouse/staff',
        {
          withCredentials: true
        }
      );
    },
    //查询渠道
    findAllChannle() {
      return this.$request1.get(
        '/system/channel/all',
        {
          withCredentials: true
        }
      );
    },
    //查询客户
    findAllCustomerName() {
      return this.$request1.get(
        '/customerAll',
        {
          withCredentials: true
        }
      );
    },
    fileUpload(id) {
      document.getElementById(id).click();
    },
    reset() {
      this.conditions = {
        status: "AIR_SHIPPING",
        isDone: "未完成",
        capacity: "",
        container: "",
        order: "",
        batchIdTextArea: "",
        startDate: "",
        endDate: "",
        searchTextArea: "",
        currentPage: 1,
        pageSize: 10
      };
      this.onSubmit();
    },
    search() {
      this.conditions.currentPage = 1;
      this.onSubmit();
    },
    //搜索
    onSubmit() {
      let _this = this;
      let batch = this.conditions.batchIdTextArea.split(/\n+/gim).map(a => a.trim()).filter(a => a);
      let search = this.conditions.searchTextArea.split(/\n+/gim).map(a => a.trim()).filter(a => a);      

      let conditions = {
        done: this.conditions.isDone === "已完成",
        channelType: this.conditions.status,
        transportCapacityId: this.conditions.capacity,
        batchNumber: batch,
        containerNumber: this.conditions.container,
        orderId: this.conditions.order,
        startDate: this.conditions.startDate,
        endDate: this.conditions.endDate,
        search: search,
        type: this.conditions.type,
        currentPage: this.conditions.currentPage,
        pageSize: this.conditions.pageSize
      };

      _this.$request1
        .post(
          '/batch/query',
          conditions,
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.tableData = res.data.data.batchRichValues;
            _this.amountOrder = res.data.data.amountOrder;
            _this.amountOrder1 = res.data.data.amountOrder;
            if (_this.tableData && _this.tableData.length > 0) {
              _this.tableData.forEach((d, i) => {
                _this.$set(d, "check", false);
                if (_this.conditions.status && _this.conditions.status !== "") {
                  _this.$set(d, "channelType", _this.conditions.status);
                }
              });
            }
            _this.total = res.data.total;
          } else {
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadCapaticy() {
      let _this = this;

      _this.$request1
        .get(
          '/capacity/load',
          {
            params: {
              name: "",
              supplierId: "",
              channelType: "",
              currentPage: 1,
              pageSize: 1000
            }
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.capacityList) {
            _this.capaticyList = res.data.capacityList;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    shipment() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      _this.loadDetail(_this.multipleSelection[0].id);

      _this.shipmentValue = [];
      _this.clearVisible = true;
    },
    loadDetail(id, type) {
      let _this = this;
      if (!id || id == "") {
        _this.$message.error("id is null");
        return false;
      }
      _this.$request1
        .get(
          '/batchdetial',
          {
            params: {
              id: id
            }
          },
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.batchDetail = res.data.data;
            if (
              typeof type != "undefined" &&
              type == "customsDeclarationForm"
            ) {
              _this.customsDeclarationForm.batchId = _this.batchDetail.batchId;
              _this.customsDeclarationForm.containerNumber =
                _this.batchDetail.containerNumber;
              _this.customsDeclarationForm.qty = _this.batchDetail.qty;
            } else if (typeof type != "undefined" && type == "departureForm") {
              _this.departureForm.batchId = _this.batchDetail.batchId;
              _this.departureForm.containerNumber =
                _this.batchDetail.containerNumber;
              _this.departureForm.qty = _this.batchDetail.qty;
            } else if (typeof type != "undefined" && type == "arrivalForm") {
              _this.arrivalForm.batchId = _this.batchDetail.batchId;
              _this.arrivalForm.containerNumber =
                _this.batchDetail.containerNumber;
              _this.arrivalForm.qty = _this.batchDetail.qty;
            } else if (
              typeof type != "undefined" &&
              type == "inOverseasWarehouseForm"
            ) {
              _this.inOverseasWarehouseForm.batchId = _this.batchDetail.batchId;
              _this.inOverseasWarehouseForm.containerNumber =
                _this.batchDetail.containerNumber;
              _this.inOverseasWarehouseForm.qty = _this.batchDetail.qty;
            }
          } else {
            _this.$message.error("id is null");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    initVehicle(licensePlate) {
      this.$request1({
        method: "GET",
        url: '/system/vehicle/queryLicensePlate',
        params: {
          licensePlate: licensePlate,
          currentPage: 1,
          pageSize: 10000
        }
      })
        .then(response => {
          let vehicleList = response.data.data;
          if (vehicleList && vehicleList.length > 0) {
            this.vehicleData = vehicleList;
          } else {
            this.vehicleData = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    initDriver(name) {
      this.$request1({
        method: 'GET',
        url: '/system/driver/query',
        params: {
          name: name,
          currentPage: 1,
          pageSize: 10000
        }
      })
        .then(response => {
          if (response.data.data && response.data.data.length > 0) {
            this.driverData = response.data.data;
          } else {
            this.driverData = [];
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    showChangeShipment(row) {
      let _this = this;
      let rmIndex = 0;
      _this.vehicleData.forEach((d, i) => {
        if (d.id == row) {
          rmIndex = i;
        }
      });
      //_this.vehicleData.splice(0, 1);
      _this.shipmentValue.forEach((d, i) => {
        _this.vehicleDataCache = [];
      });
    },
    changeShipment() {
      let _this = this;
      let shipmentVehicles = new Array();
      let _check = false;
      _this.shipmentValue.forEach((d, i) => {
        let _vehicle = new Object();
        if (
          !d.vehicle ||
          !d.driver ||
          d.vehicle.length == 0 ||
          d.driver.length == null ||
          d.driver.length == 0
        ) {
          _check = true;
        }
        _vehicle.id = d.vehicle;
        _vehicle.driverIds = d.driver;
        shipmentVehicles.push(_vehicle);
      });

      if (_check) {
        _this.$message.error("请填写运送车辆和司机");
        return false;
      }
      let _orderIds = new Array();
      _this.batchDetail.order.forEach((d, i) => {
        _orderIds.push(d.orderId);
      });

      this.$request1
        .post(
          '/batch-operation/shipment',
          {
            batchId: _this.batchDetail.batchId,
            orderIds: _orderIds,
            qty: _this.batchDetail.qty,
            shipmentVehicles: shipmentVehicles
          }
        )
        .then(res => {
          if (res.data.success) {
            _this.$message.success("success");
            _this.clearVisible = false;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    intoSupervisoryWarehouse() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let _batchId = _this.multipleSelection[0].id;

      this.$request1
        .get(
          '/batch-operation/intoSupervisoryWarehouse',
          {
            params: {
              batchId: _batchId
            }
          }
        )
        .then(res => {
          if (res.data.success) {
            _this.$message.success("success");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    goodsInfoExport() {
      let _this = this;
      let list = this.multipleSelection;
      if (!list || list.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let arrayId = [];
      for (let i = 0; i < list.length; i++) {
        arrayId.push(list[i].id);
      }
      // var url = tmsSpringUrl + '/order/goods-info';
      // var form = document.getElementById("myform");
      // form.setAttribute("action", url);
      // var fhtml = "";
      // fhtml +=
      //   '<input type="hidden" name="orderIds" value="' +
      //   arrayId.join(",") +
      //   '" />';
      // fhtml += '<input type="hidden" name="type" value="batch" />';

      // fhtml +=
      //   '<input type="hidden" name="token" value="' +
      //   this.$getToken() +
      //   '" />';
      // form.innerHTML = fhtml;
      // //console.log(form);
      // form.submit();
      let formData = {
        orderIds: arrayId.join(","),
        type: "batch"
      }
      this.$request1({
          url: '/order/goods-info',
          method: 'post',
          data: formData
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `goods_info_batch_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据');
          }          
        })
    },
    orderPrintExport() {
      let _this = this;
      let list = this.multipleSelection;

      if (!list || list.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let arrayId = [];
      for (let i = 0; i < list.length; i++) {
        arrayId.push(list[i].id);
      }
      //console.log(arrayId);

      var url = tmsSpringUrl + '/order/order-print';

      var form = document.createElement("form");
      form.method = "get";
      form.action = url;
      form.target = "_blank";
      document.body.appendChild(form);

      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "batchIds";
      input.value = arrayId.join(",");
      form.appendChild(input);

      var input2 = document.createElement("input");
      input2.type = "hidden";
      input2.name = "token";
      input2.value = this.$getToken()
      form.appendChild(input2);
      //console.log(form);
      form.submit();
    },
    // 导出出货跟进表
    orderShipmentExport () {
      let _this = this;
      let list = this.multipleSelection;

      if (!list || list.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let arrayId = [];
      for (let i = 0; i < list.length; i++) {
        arrayId.push(list[i].id);
      }

      var url = '/download/batch/follow_up';
      _this.$request1.post(url, 
        arrayId,
        {responseType:'arraybuffer'},
      ).then((res)=>{
        if(res.data) {
        const link = document.createElement('a')
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', '出货跟进表.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        }
        else {
          this.$toast.error('导出失败')
        }
      })
    },
    // 导出子单签出时间
    downloadsonOrderSingOut () {
         if (
        this.begintime.length == 0 ||
        this.endtime.length == 0
      ) {
        this.$message({
          message: "请选择开始日期和结束日期",
          type: "warning"
        });
        return;
      }
      let url='/batch-operation/download/subOrderDelivery';
       this.$request1({
        method: 'GET',
        url: '/batch-operation/download/subOrderDelivery',
        params: {
          startDate: this.begintime,
          endDate: this.endtime
        }
      }).then((res)=>{
         if (!res.data.success) {
          this.$notify.error({
            title: "提示",
            message: res.data.message
          });
          return;
        }
        if (res.data.data) {
          var byteCharacters = atob(res.data.data);

          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          let blob = new Blob([byteArray], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let objectUrl = URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = objectUrl;
          a.download = "sonorder_singout.xlsx";
          a.click();
        } else {
          this.$notify.error({
            title: "提示",
            message: "导出批次明细时间失败"
          });
        }
        this.sonOrderSingOutdialog = false;
      });
    },
    showCustomsDeclaration(type) {
      let _this = this;

      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let _batchId = _this.multipleSelection[0].id;
      _this.loadDetail(_batchId, "customsDeclarationForm");
      _this.loadCustoms(type);
      _this.loadCustomsDeclaration(_batchId, type);
    },
    loadCustomsDeclaration(batchId, type) {
      let _this = this;
      this.$request1
        .get(
          '/batch-operation/customsDeclaration',
          {
            params: {
              type: type,
              batchId: batchId
            }
          }
        )
        .then(res => {
          if (res.data.success) {
            _this.customsDeclarationForm = {
              customsDeclarationStartDate: res.data.data.startDate,
              customsDeclarationEndDate: res.data.data.endDate,
              customsDeclarationId: res.data.data.customsId,
              customsDeclarationStatus: res.data.data.status
            };
            if (type == "CUSTOMS_BROKER") {
              _this.clearanceVisible = true;
            } else if (type == "BROKER") {
              _this.customsVisible = true;
            }
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    customsDeclarationSetStartDate(type) {
      let _this = this;
      if (!_this.customsDeclarationForm.customsDeclarationStartDate) {
        _this.$message.error("请选择开始时间");
        return false;
      }
      _this.customsDeclarationSubmit(
        type,
        _this.customsDeclarationForm.batchId,
        _this.customsDeclarationForm.customsDeclarationStartDate
      );
    },
    customsDeclaration(type) {
      let _this = this;
      let _valid = _this.$refs["customsDeclarationFormRef"].validate(valid => {
        if (valid) {
          _this.customsDeclarationSubmit(
            type,
            _this.customsDeclarationForm.batchId,
            _this.customsDeclarationForm.customsDeclarationStartDate,
            _this.customsDeclarationForm.customsDeclarationEndDate,
            _this.customsDeclarationForm.customsDeclarationId,
            _this.customsDeclarationForm.customsDeclarationStatus
          );
        } else {
          return false;
        }
      });
      if (!_valid) {
        return false;
      }
    },
    customsDeclarationSubmit(
      type,
      batchId,
      startDate,
      endDate,
      customsId,
      status
    ) {
      let _this = this;

      this.$request1
        .post(
          '/batch-operation/customsDeclaration',
          {
            type: type,
            batchId: batchId,
            startDate: startDate,
            endDate: endDate,
            customsId: customsId,
            status: status
          }
        )
        .then(res => {
          if (res.data.success) {
            _this.$message.success("success");
            _this.clearanceVisible = false;
            _this.customsVisible = false;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    loadCustoms(customsType) {
      //报关行
      this.$request1({
        method: 'GET',
        url: '/customs/load',
        params: {
          customsType: customsType,
          customsName: "",
          currentPage: 1,
          pageSize: 10000
        }
      })
        .then(response => {
          if (customsType == "CUSTOMS_BROKER") {
            this.customsDeclarationList = response.data.data;
          } else if (customsType == "BROKER") {
            this.customsDeclarationList2 = response.data.data;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //出发
    showDeparture() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let _batchId = _this.multipleSelection[0].id;
      _this.loadDetail(_batchId, "departureForm");

      this.$request1
        .get(
          '/batch-operation/departure',
          {
            params: {
              batchId: _batchId
            }
          }
        )
        .then(res => {
          if (res.data.success) {
            _this.departureForm.date = res.data.data.date;
            _this.departureForm.number = res.data.data.number;
            _this.departVisible = true;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    departure() {
      let _this = this;
      let _valid = _this.$refs["departureFormRef"].validate(valid => {
        if (valid) {
          this.$request1
            .post(
              '/batch-operation/departure',
              {
                batchId: _this.departureForm.batchId,
                date: _this.departureForm.date,
                number: _this.departureForm.number
              }
            )
            .then(res => {
              if (res.data.success) {
                _this.$message.success("success");
                _this.departVisible = false;
              } else {
                _this.$message.error(res.data.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
      if (!_valid) {
        return false;
      }
    },
    showArrival() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let _batchId = _this.multipleSelection[0].id;
      _this.loadDetail(_batchId, "arrivalForm");

      this.$request1
        .get(
          '/batch-operation/arrival',
          {
            params: {
              batchId: _batchId
            }
          }
        )
        .then(res => {
          if (res.data.success) {
            _this.arrivalForm.date = res.data.data.date;
            _this.toVisible = true;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    arrival() {
      let _this = this;
      let _valid = _this.$refs["arrivalFormRef"].validate(valid => {
        if (valid) {
          this.$request1
            .post(
              '/batch-operation/arrival',
              {
                batchId: _this.arrivalForm.batchId,
                date: _this.arrivalForm.date
              }
            )
            .then(res => {
              if (res.data.success) {
                _this.$message.success("success");
                _this.toVisible = false;
              } else {
                _this.$message.error(res.data.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
      if (!_valid) {
        return false;
      }
    },
    showInOverseasWarehouse() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let _batchId = _this.multipleSelection[0].id;
      _this.loadDetail(_batchId, "inOverseasWarehouseForm");

      this.$request1
        .get(
          '/batch-operation/inOverseasWarehouse',
          {
            params: {
              batchId: _batchId
            }
          }
        )
        .then(res => {
          if (res.data.success) {
            _this.inOverseasWarehouseForm.number = res.data.data.qty;
            _this.werehouseVisible = true;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    inOverseasWarehouse() {
      let _this = this;
      let _valid = _this.$refs["inOverseasWarehouseFormRef"].validate(valid => {
        if (valid) {
          this.$request1
            .post(
              '/batch-operation/inOverseasWarehouse',
              {
                batchId: _this.inOverseasWarehouseForm.batchId,
                qty: _this.inOverseasWarehouseForm.number
              }
            )
            .then(res => {
              if (res.data.success) {
                _this.$message.success("success");
                _this.werehouseVisible = false;
              } else {
                _this.$message.error(res.data.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          return false;
        }
      });
      if (!_valid) {
        return false;
      }
    },
    operationDistributionCompleted() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let _batchId = _this.multipleSelection[0].id;

      this.$request1
        .get(
          '/batch-operation/distributionCompleted',
          {
            params: {
              batchId: _batchId
            }
          }
        )
        .then(res => {
          console.log("done", res);
          if (res.data.success) {
            _this.$message.success("success");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    showBatchAttribute(row, key) {
      let _this = this;
      let _val = "";
      if (row.batchAttribute && row.batchAttribute.length > 0) {
        row.batchAttribute.forEach((d, i) => {
          if (d.attributeKey == key) {
            if (key == "transport_vehicles") {
              //运送车辆
              if (d.attributeValue && d.attributeValue.length > 0) {
                d.attributeValue.split(",").forEach((d, i) => {
                  _this.vehicleData.forEach((vd, vi) => {
                    if (vd.id == d) {
                      _val += vd.licensePlate + "\n";
                    }
                  });
                });
              }
            } else if (key == "transport_drivers") {
              //司机
              if (d.attributeValue && d.attributeValue.length > 0) {
                d.attributeValue.split(",").forEach((d, i) => {
                  _this.driverData.forEach((vd, vi) => {
                    if (vd.id == d) {
                      _val += vd.name + "\n";
                    }
                  });
                });
              }
            } else if (key == "customs_declaration_customs") {
              //报关行
              if (d.attributeValue && d.attributeValue.length > 0) {
                d.attributeValue.split(",").forEach((d, i) => {
                  _this.customsDeclarationList.forEach((vd, vi) => {
                    if (vd.customsId == d) {
                      _val += vd.customsName + "\n";
                    }
                  });
                });
              }
            } else if (key == "customs_clearance_customs") {
              //清关行
              if (d.attributeValue && d.attributeValue.length > 0) {
                d.attributeValue.split(",").forEach((d, i) => {
                  _this.customsDeclarationList2.forEach((vd, vi) => {
                    if (vd.customsId == d) {
                      _val += vd.customsName + "\n";
                    }
                  });
                });
              }
            } else if (key == "whether_the_inspection") {
              //是否查验
              if (d.attributeValue && d.attributeValue.length > 0) {
                _val = d.attributeValue == "true" ? "是" : "否";
              }
            } else {
              _val = d.attributeValue;
            }
          }
        });
      }
      return _val;
    },
    //编辑
    handleEdit(row) {
      sessionStorage.setItem(
        "batch_conditions",
        JSON.stringify(this.conditions)
      );
      sessionStorage.setItem("batch_tableData", JSON.stringify(this.tableData));
      sessionStorage.setItem(
        "batch_amountOrder",
        JSON.stringify(this.amountOrder)
      );
      sessionStorage.setItem(
        "batch_isSearchMore",
        JSON.stringify(this.isSearchMore)
      );

      this.$router.push({
        path: "/orderoperation/batchoperation/edit",
        query: {
          id: row.id,
          channelType: row.channelType
        }
      });

      return;

      let _this = this;
      this.dialogEditVisible = true;
      this.tableIndex = index;
      _this.editForm = {
        id: "",
        remarks: "",
        batchAttribute: {
          container_number: "",
          delivery_time: "",
          transport_vehicles: [],
          transport_drivers: [],
          inner_delivery_time: "",
          time_in_custody: "",
          inner_time_in_custody: "",
          customs_declaration_enddate: "",
          inner_customs_declaration_enddate: "",
          departure_time: "",
          inner_departure_time: "",
          sailing_time: "",
          inner_sailing_time: "",
          driving_time: "",
          inner_driving_time: "",
          landing_time: "",
          inner_landing_time: "",
          port_time: "",
          inner_port_time: "",
          arrival_time: "",
          inner_arrival_time: "",
          customs_clearance_enddate: "",
          inner_customs_clearance_enddate: "",
          delivery_time_to_warehouse: "",
          inner_delivery_time_to_warehouse: "",
          completion_time_of_the_goods: "",
          inner_completion_time_of_the_goods: "",
          extraction_time: "",
          notice_of_the_date_of_inspection: "",
          inner_notice_of_the_date_of_inspection: "",
          release_date: "",
          inner_release_date: ""
        }
      };
      _this.tableData.forEach((d, i) => {
        d.check = false;
      });
      // row.check = true;
      for (let _key in row) {
        if (row[_key] instanceof Array) {
          row[_key].forEach((d, i) => {
            if (d.attributeKey == "transport_vehicles") {
              if (d.attributeValue && d.attributeValue.length > 0) {
                _this.editForm.batchAttribute[
                  d.attributeKey
                ] = d.attributeValue.split(",");
              } else {
                _this.editForm.batchAttribute[d.attributeKey] = [];
              }
            } else if (d.attributeKey == "transport_drivers") {
              if (d.attributeValue && d.attributeValue.length > 0) {
                _this.editForm.batchAttribute[
                  d.attributeKey
                ] = d.attributeValue.split(",");
              }
            } else if (d.attributeKey == "whether_the_inspection") {
              if (d.attributeValue && d.attributeValue.length > 0) {
                _this.editForm.batchAttribute[d.attributeKey] =
                  d.attributeValue == "true";
              }
            } else if (d.attributeKey == "customs_fee_list") {
              _this.editForm.batchAttribute.customs_fee_list = d.attributeValue.split(
                ","
              );
              _this.customsFeeList =
                _this.editForm.batchAttribute.customs_fee_list;
            } else {
              _this.editForm.batchAttribute[d.attributeKey] = JSON.parse(
                JSON.stringify(d.attributeValue)
              );
            }
          });
        } else {
          _this.editForm[_key] = JSON.parse(JSON.stringify(row[_key]));
        }
      }
    },
    //保存
    handleSave() {
      let _this = this;

      let _temEditForm = JSON.parse(JSON.stringify(_this.editForm));
      let row = _this.tableData[_this.tableIndex];
      console.log(_temEditForm);
      for (let _key in _temEditForm) {
        if (_key == "batchAttribute") {
          row[_key] = new Array();
          for (let _atkey in _temEditForm.batchAttribute) {
            if (_temEditForm.batchAttribute[_atkey] instanceof Array) {
              if (_temEditForm.batchAttribute[_atkey].length > 0) {
                row[_key].push({
                  attributeKey: _atkey,
                  attributeValue: _temEditForm.batchAttribute[_atkey].toString()
                });
              } else {
                row[_key].push({
                  attributeKey: _atkey,
                  attributeValue: ""
                });
              }
            } else {
              if (_atkey == "whether_the_inspection") {
                console.log(_temEditForm.batchAttribute[_atkey]);
                row[_key].push({
                  attributeKey: _atkey,
                  attributeValue: _temEditForm.batchAttribute[_atkey]
                    ? "true"
                    : "false"
                });
              } else {
                row[_key].push({
                  attributeKey: _atkey,
                  attributeValue: _temEditForm.batchAttribute[_atkey]
                });
              }
            }
          }
        } else {
          row[_key] = _temEditForm[_key];
        }
      }

      // console.log(row);

      let attributes = new Object();
      row.batchAttribute.forEach((d, i) => {
        attributes[d.attributeKey] = d.attributeValue;
      });

      this.$request1
        .post(
          '/batch-operation',
          {
            id: row.id,
            remarks: row.remarks,
            attributes: JSON.stringify(attributes)
          }
        )
        .then(res => {
          this.dialogEditVisible = false;
          _this.tableIndex = -1;
        })
        .catch(error => {
          console.log(error);
        });

      row.check = false;
    },
    getFileUrl(row, type) {
      return (
        '/batch-operation/upload/' +
        "?batchId=" +
        row.id +
        "&key=" +
        type
      );
    },
    uploadFileInspectionBill(file, fileList) {
      let _this = this;
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("batchId", this.editForm.id);
      formData.append("key", "inspection_bill");

      this.$request1
        .post(
          '/batch-operation/upload/',
          formData,
          {
            withCredentials: true
          }
        )
        .then(res => {
          console.info("res:" + JSON.stringify(res));
          if (res.status == 413) {
            this.$notify.error({
              title: "创建订单失败,异常提示:",
              message:
                "Excel文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          }
          if (res.data.success) {
            _this.editForm.batchAttribute.inspection_bill = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response.status === 413) {
            _this.fileListI = [];
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    //文件上传成功 
    handleSuccess (response, file, fileList) {
      // console.log(fileList)
    },
    uploadFileCustomsFeeList(file, fileList) {
      let _this = this;

      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("batchId", this.editForm.id);
      formData.append("key", "customs_fee_list");

      this.$request1
        .post(
          '/batch-operation/upload/',
          formData,
          {
            withCredentials: true
          }
        )
        .then(res => {
          if (res.status == 413) {
            this.$notify.error({
              title: "创建订单失败,异常提示:",
              message:
                "Excel文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          }
          if (res.data.success) {
            console.log(_this.editForm.batchAttribute.customs_fee_list);
            _this.editForm.batchAttribute.customs_fee_list.push(res.data.data);
            console.log(_this.editForm.batchAttribute.customs_fee_list);
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response.status === 413) {
            _this.fileListC = [];
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message:
                "文件超过规定大小，限制最大不超过10MB，请精简其中图片内容后重新上传。"
            });
          } else {
            _this.$notify.error({
              title: "请求失败,异常提示:",
              message: error.response.statusText,
              duration: 0
            });
          }
        });
    },
    getCustomsDownloadUrl(fileName) {
      let _this = this;
      let bool = _this.dialogEditVisible;
      let _fileName = bool ? fileName : fileName; //true 说明编辑窗口打开，false 说明在列表页
      if (!_fileName || _fileName == "") {
        _this.$message.error("请先上传文件");
        return false;
      }
      this.$request1
        .post(
          '/batch-operation/download/' + _fileName + ''
        )
        .then(res => {
          if (res.data.success) {
            _this.window.location.href = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteFile(index, fileName, batchId, key) {
      let _this = this;
      let bool = _this.dialogEditVisible;
      let _fileName = bool ? fileName : fileName; //true 说明编辑窗口打开，false 说明在列表页
      if (!_fileName || _fileName == "") {
        _this.$message.error("请先上传文件");
        return false;
      }
      this.$request1({
        method: 'DELETE',
        url: '/batch-operation/' + _fileName + '/' + batchId + '/' + key + '',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            _this.customsFeeList.splice(index, 1);
            _this.editForm.batchAttribute.customs_fee_list =
              _this.customsFeeList;
            this.$notify.success({
              title: "成功",
              message: "删除成功"
            });
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {});
    },
    getDownloadUrl(fileType) {
      let _this = this;
      let bool = _this.dialogEditVisible;
      let _fileName = bool ? _this.editForm.batchAttribute[fileType] : fileType; //true 说明编辑窗口打开，false 说明在列表页
      if (!_fileName || _fileName == "") {
        _this.$message.error("请先上传文件");
        return false;
      }
      this.$request1
        .post(
          '/batch-operation/download/' + _fileName + ''
        )
        .then(res => {
          if (res.data.success) {
            _this.window.location.href = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    showDetail(row) {
      let _this = this;
      if (!row) {
        return false;
      }
      _this.dialogTableVisible = true;
      _this.loadDetail(row.id);
    },
    showCarton(index) {
      this.cartonList = this.batchDetail.order[index];
      this.tableVisible = true;
    },
    batchDone(row) {
      if (!row.calculateCharge) {
        this.$message({
          message: "批次 [ " + row.id + " ] 没有计费",
          type: "warning"
        });
        return;
      }
      this.$confirm("您确定要结束该批次吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let _this = this;
          if (!row) {
            return false;
          }
          this.$request1
            .get(
              '/batch-operation/batchDone',
              {
                params: {
                  batchId: row.id
                }
              }
            )
            .then(res => {
              console.log("done", res);
              if (res.data.success) {
                _this.$message.success("success");
                _this.onSubmit();
              } else {
                _this.$message.error(res.data.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    costDone(row) {
      this.$confirm("您确定要批次费用完成?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let _this = this;
          if (!row) {
            return false;
          }
          this.$request1
            .get(
              '/batch-operation/cost_done',
              {
                params: {
                  batchId: row.id
                }
              }
            )
            .then(res => {
              if (res.data.success) {
                _this.$message.success("success");
                _this.onSubmit();
              } else {
                _this.$message.error(res.data.message);
              }
            })
            .catch(error => {
              console.log(error);
            });
        })
        .catch(error => {
          console.log(error);
        });
    },
    queryAddBatchOrder() {
      this.addOrderQueryForm.orderIds = [];
      if (
        this.addOrderQueryOrderIds !== null &&
        this.addOrderQueryOrderIds !== ""
      ) {
        let queryOrderIds = this.addOrderQueryOrderIds.split(/[\n]+/);
        for (let item of queryOrderIds) {
          if (item.trim() != "") {
            if (this.addOrderQueryForm.orderIds.indexOf(item) == -1) {
              this.addOrderQueryForm.orderIds.push(item);
            }
          }
        }
      }
      // return;
      this.$request1({
        method: 'post',
        url: '/operation/allocation/query',
        withCredentials: true,
        data: {
          status: -1,
          currentPage: this.batchCurrentPage,
          pageSize: this.batchPageSize,
          productIds: this.addOrderQueryForm.productIds,
          orderIds: this.addOrderQueryForm.orderIds
        }
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            let taskData = data.data;
            this.batchTotal = data.total;
            if (this.batchTotal > 0) {
              this.penddingTableData = taskData;
            } else {
              this.penddingTableData = [];
              this.batchTotal = 0;
            }
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    queryAddBatchOrderTask() {
      this.currentPage = 1;
      this.batchCurrentPage = 1;
      this.queryAddBatchOrder();
    },
    formateDate(date) {
      return (
        new Date(date).getFullYear() +
        "-" +
        ("0" + (new Date(date).getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + new Date(date).getDate()).slice(-2) +
        " " +
        ("0" + new Date(date).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(date).getMinutes()).slice(-2) +
        ":" +
        ("0" + new Date(date).getSeconds()).slice(-2)
      );
    },
    //****批次添加订单分页
    handleBatchSizeChange(val) {
      this.batchPageSize = val;
      this.batchCurrentPage = 1;
      this.queryAddBatchOrder();
    },
    handleBatchCurrentChange(val) {
      this.batchCurrentPage = val;
      this.queryAddBatchOrder();
    },
    handleOrderSelectionChangeForInsurance(val){
      this.insuranceOrderSelection = val;
    },
    //选择选择运力的订单
    handleOrderSelectionChange(val) {
      this.capcaityOrderSelection = val;
      this.selectOrderChannelIds = [];
      this.currentTotalWeight = 0;
      this.currentTotalVolume = 0;

      this.totalOrder = this.capcaityOrderSelection.length;
      this.totalCarton = 0;
      this.totalVolume = 0;
      this.totalWeight = 0;
      this.capcaityOrderSelection.forEach((select, index) => {
        this.currentTotalWeight += select.totalWeight;
        this.currentTotalVolume += select.totalVolume;
        if (this.selectOrderChannelIds.indexOf(select.procutId) == -1) {
          this.selectOrderChannelIds.push(select.procutId);
        }
        this.totalCarton += select.totalCarton;
        this.totalVolume += select.totalVolume;
        this.totalWeight += select.totalWeight;
      });
      //转换为m³
      this.currentTotalVolume = this.toFixed(
        this.currentTotalVolume / 1000000,
        6
      );

      if (this.capcaityOrderSelection.length == 0) {
        this.totalOrder = this.totalOrder1;
        this.totalCarton = this.totalCarton1;
        this.totalVolume = this.totalVolume1;
        this.totalWeight = this.totalWeight1;
      }
    },
    cancelAddOrderToBatch() {
      this.addOrderTobatchDialog = false;
    },
    saveAddOrderToBatch() {
      if (this.capcaityOrderSelection.length == 0) {
        this.$message.error("请选择订单");
        return;
      }
      let capacityOrderIds = [];
      this.capcaityOrderSelection.forEach(element => {
        capacityOrderIds.push(element.id);
      });

      if (
        this.batchUsableTransportCapacityValue.priority == "WEIGHT" &&
        this.batchUsableTransportCapacityValue.weightLimit <
          this.currentTotalWeight
      ) {
        this.$message.error("选择订单的总重量不能大于运力剩余可用重量");
        return;
      }
      if (
        this.batchUsableTransportCapacityValue.priority == "VOLUME" &&
        this.batchUsableTransportCapacityValue.volumeLimit <
          this.currentTotalVolume
      ) {
        this.$message.error("选择订单的总体积不能大于运力剩余可用体积");
        return;
      }
      this.$request1({
        method: 'POST',
        url: '/operation/allocation/batch-addorder',
        data: {
          batchId: this.orderTobatchId,
          capacityId: this.batchUsableTransportCapacityValue.id,
          usageDate: this.batchUsableTransportCapacityValue.effectiveDate,
          totalWeight: this.currentTotalWeight,
          totalVolume: this.currentTotalVolume,
          capacityOrderIds: capacityOrderIds,
          capacityStatus: 1,
          batchOperation: true
        },
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.$notify({
              title: "成功",
              message: data.message,
              type: "success"
            });
            this.addOrderTobatchDialog = false;
            setTimeout(() => {
              // this.query();   根本就没有query方法
              this.onSubmit();
            }, 2000);
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
          this.findCapacityData();
        })
        .catch(error => {
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    //批次里添加订单
    addOrderToBatch(row) {
      if (row.calculateCharge) {
        this.$message({
          message: "批次 [ " + row.id + " ] 已计费，无法添加新的订单",
          type: "warning"
        });
        return;
      }
      let batchId = row.id;
      this.orderTobatchId = batchId;
      //获取运力信息
      this.$request1({
        method: 'GET',
        url: '/operation/allocation/' + batchId + '/capacity',
        withCredentials: true
      })
        .then(response => {
          let data = response.data;
          if (data.success) {
            this.batchUsableTransportCapacityValue = data.data;
            this.queryAddBatchOrderTask();
            this.addOrderQueryOrderIds = "";
            this.addOrderTobatchDialog = true;
          } else {
            this.$notify.error({
              title: "错误",
              message: data.message
            });
          }
        })
        .catch(error => {
          if (error.response) {
            this.$notify.error({
              title: "错误",
              message: error.response.data
            });
          }
        });
    },
    saveRemark(row) {
      let _this = this;
      this.$request1
        .get(
          '/order/remark',
          {
            params: {
              orderId: row.orderId,
              remark: row.remark
            }
          }
        )
        .then(res => {
          if (res.data.success) {
            _this.$message.success("success");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //增加
    handleAdd(arr) {
      arr.push({ vehicle: null });
      console.log(arr);
    },
    //删除
    carDelete(i, d, arr) {
      arr.splice(i, 1);
      console.log(index, row);
    },
    //多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.amountOrder = 0;
      val.forEach((item, index) => {
        this.amountOrder += item.totalOrder;
      });

      if (val.length == 0) {
        this.amountOrder = this.amountOrder1;
      }
    },
    //分页
    handleSizeChange(val) {
      this.conditions.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.conditions.currentPage = val;
      this.onSubmit();
    },
    // 导出batch基础数据报表
    exportBatchBaseData(){
      let _this = this
      // if(!this.conditions.startDate || !this.conditions.endDate){
      //   this.$message.error("请选择开始日期、结束日期");
      //   this.isSearchMore = true;
      //   return
      // }
      if(!this.multipleSelection || this.multipleSelection.length == 0){
        this.$message.error("请勾选批次")
        return
      }
      this.conditions.checkedBatchIds = this.multipleSelection.map(item => item.id)

      // 保存POD
      this.$request1({
        method: 'post',
        // url: `${springHost}batch/export-batch-base-data`,
        url: `batch/export-batch-base-data`,
        data: this.conditions
      }).then(res => {
        if(res.data.success){
          _this.$message.success("导出成功");

          const link = document.createElement('a')
          const array = base64ToUint8Array(res.data.data)
          const blob = new Blob([array])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)

          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `星邮轨迹基础数据表__${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

        }else{
          this.$message.error(res.data.message)
        }
      })

      
    },
    downloadGoodsInfo() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let ids = new Array();
      this.multipleSelection.forEach((d, i) => {
        ids.push(d.id);
      });
      // this.$windowOpen1(
      //   '/batch-operation/download/goodsinfo' +
      //     "?ids=" +
      //     ids.toString() +
      //     "&type=batch"
      // );
      this.$request1({
          url: '/batch-operation/download/goodsinfo',
          method: 'post',
          data: {
            ids: ids,
            type: 'batch'
          }
        }).then(res => {
          if(res.data.success && res.data.data!=null && res.data.data.length>0){
            
            const link = document.createElement('a')
            let array = base64ToUint8Array(res.data.data)
            let blob = new Blob([array])
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
            link.setAttribute('download', `订单信息表导出_${timestr}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }else{
            this.$message.error('没有数据:' + res.data.message);
          }          
        })
    },
    // 导出批次 上网统计
    exportInternet(){
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }

      var url = tmsSpringUrl + '/batch/export/internet';

      var form = document.createElement("form");
      form.method = "post";
      form.action = url;
      form.target = "_blank";
      document.body.appendChild(form);

      // this.multipleSelection.forEach(a => {
        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "idsTxt";
        input.value = this.multipleSelection.map(a => a).join(",");
        form.appendChild(input);
      // });


      var input2 = document.createElement("input");
      input2.type = "hidden";
      input2.name = "token";
      input2.value = this.$getToken()
      form.appendChild(input2);

      form.submit();

    },
    downloadSeaOrder() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let ids = new Array();
      this.multipleSelection.forEach((d, i) => {
        ids.push(d.id);
      });

      this.$windowOpen1(
        '/batch-operation/download/sea-order' +
          "?batchIds=" +
          ids.toString()
      );
    },
    downloadUSAirOrder() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let ids = new Array();
      this.multipleSelection.forEach((d, i) => {
        ids.push(d.id);
      });
      this.$windowOpen1(
        '/batch-operation/download/usa-air-order' +
          "?batchIds=" +
          ids.toString()
      );
    },
    downloadJPSeaOrder() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let ids = new Array();
      this.multipleSelection.forEach((d, i) => {
        ids.push(d.id);
      });
      this.$windowOpen1(
        '/batch-operation/download/japan-sea-order' +
          "?batchIds=" +
          ids.toString()
      );
    },
    downloadEURAirOrder() {
      let _this = this;
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        _this.$message.error("请选择批次");
        return false;
      }
      let ids = new Array();
      this.multipleSelection.forEach((d, i) => {
        ids.push(d.id);
      });
      this.$windowOpen1(
        '/batch-operation/download/eur-air-order' +
          "?batchIds=" +
          ids.toString()
      );
    },
    toFixed(num, len) {
      if (!num || isNaN(num)) {
        return "";
      }
      var times = Math.pow(10, len);
      var des = num * times + 0.5;
      return parseInt(des, 10) / times;
    },
    finishBatchOrderDel(batchId, orderId) {
      this.$confirm("确定将订单移除本批次吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let id = null;
          this.$request1({
            method: 'post',
            url: '/operation/allocation/delete',
            params: {
              batchId: batchId,
              orderCapacityId: null,
              orderId: orderId
            },
            withCredentials: true
          })
            .then(response => {
              let data = response.data;
              if (data.success) {
                this.$notify({
                  title: "成功",
                  message: "删除成功",
                  type: "success"
                });
                this.onSubmit();
                this.dialogTableVisible = false;
              } else {
                this.$notify.error({
                  title: "错误",
                  message: data.message
                });
              }
            })
            .catch(error => {
              if (error.response) {
                this.$notify.error({
                  title: "错误",
                  message: error.response.data
                });
              }
            });
        })
        .catch(() => {
          console.log("close");
        });
    },
    delfinishBelBatch(row) {
      if (row.calculateCharge) {
        this.$message({
          message: "批次 [ " + row.id + " ] 已计费，无法删除",
          type: "warning"
        });
        return;
      }
      this.$confirm("确定删除批次?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let batchId = row.id;
          this.$request1({
            method: 'POST',
            url: '/operation/allocation/' + batchId + '/delete',
            withCredentials: true
          })
            .then(response => {
              let data = response.data;
              if (data.success) {
                this.$notify({
                  title: "成功",
                  message: "删除成功",
                  type: "success"
                });
                this.onSubmit();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: data.message
                });
              }
            })
            .catch(error => {
              if (error.response) {
                this.$notify.error({
                  title: "错误",
                  message: error.response.data
                });
              }
            });
        })
        .catch(() => {
          console.log("close");
        });
    },
    showLmOrderIds(row) {
      let url='/batch/show_lm_orderids' + "?batchId=" + row.id;
      this.$windowOpen1(url);
    },
    // 买保险弹框
    buyInsurance(row){
      let _this = this;
      
      this.batchId = row.id;

      if(row.purchaseInsurance){
        _this.$message.error("已经购买保险，不能重复购买");
        return;
      }

      this.$request1({
        method: 'get',          
        url: '/operation/batch-orderids/' + row.id + '',
        withCredentials: true,
        params: {          
        }
      })
        .then(response => {
          let data = response.data
          if (data.success) {
            this.insuranceOrderVisible = true;
            this.batchOrders = data.data;
                      
          } else {
            this.$message.error(data.message);
          }
        })
        .catch(error => {
          console.log(error);
          this.$message.error(error.response.data)
        });
    },
    // 购买保险提交
    buyInsuranceSubmit(){
      let _this = this;
      if (this.insuranceOrderSelection.length == 0) {
          this.$message.error(`请勾选要购买保险的订单`);
          return;
        }

        console.log(this.insuranceOrderSelection);

        _this
        .$confirm("批次"+_this.batchId+"是否确认购买保险?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {

          _this.$request1
            .post(
              '/insurance/batch-buy',
              {
                batchId: _this.batchId,
                orderIds: _this.insuranceOrderSelection
              },
              {
                withCredentials: true,
                headers: {
                  "content-type": "application/json"
                }
              }
            )
            .then(function(response) {
              if (response.data.success) {
                _this.$message.success("提交成功");
                _this.insuranceOrderVisible = false;

                _this.onSubmit();

              } else {
                _this.$message.error(response.data.message);
              }
            });
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消"
          });
        });

    },
    // 计费弹框
    calculationCharge(row) {
      // if (row.calculateCharge) {
      //   this.$message({
      //     message: "批次 [ " + row.id + " ] 已计费，请勿重复操作",
      //     type: "warning"
      //   });
      //   return;
      // }
      this.supplierChannelData = [
        {
          supplierChannels: [],
          supplierChannelList: [],
          serviceTypeId: "",
          supplierChannelId: "",
          calculationMethod: "",
          price: "",
          remarks: "",
          isEdit: false
        }
      ];
      this.batchId = row.id;
      this.queryServiceType();

      this.batchCostPriceData = [];
      this.$request1({
        method: 'POST',
        url: '/batch/cost-price/query',
        params: {
          batchId: row.id
        }
      })
        .then(response => {
          if (response.data.success) {
            this.batchCostPriceData = response.data.data;
          }
        })
        .catch(error => {
          this.$message.error("操作失败");
        });

      this.dialogSupplierChannelVisible = true;
    },
    // 选择供应商渠 => 确定
    calculationBatchCostCharge() {
      if (!this.checkSupplierChannel()) {
        return;
      }
      this.$confirm(
        "计费成功，将无法操作添加订单、删除订单和删除批次，是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(() => {
          let batchCostPriceForm = {
            batchId: this.batchId,
            items: []
          };
          this.supplierChannelData.forEach((item, index) => {
            let data = {
              serviceTypeId: item.serviceTypeId,
              supplierChannelId: item.supplierChannelId,
              calculationMethod: item.calculationMethod,
              price: item.price,
              stageId: index,
              shareType:item.shareType,
              remarks: item.remarks
            };
            batchCostPriceForm.items.push(data);
          });

          this.$request1({
            method: 'post',
            url: '/batch/calculation-cost',
            headers: { "content-type": "application/json" },
            responseType: "json",
            data: batchCostPriceForm
          })
            .then(response => {
              if (response.data.success) {
                this.$message({
                  message: "成功",
                  type: "success"
                });
                this.dialogSupplierChannelVisible = false;
                this.onSubmit();
              } else {
                if (response.data.data) {
                  let serviceTypeIds = response.data.data;
                  let serviceTypes = [];
                  serviceTypeIds.forEach(item => {
                    serviceTypes.push(this.serviceTypeMap[item]);
                  });
                  this.$message.error(
                    "服务类" + serviceTypes.toString() + "重复"
                  );
                } else {
                  this.$message.error(response.data.message);
                }
              }
            })
            .catch(error => {
              this.$message.error("操作失败");
            });
        })
        .catch(() => {});
    },
    // 服务类型
    queryServiceType() {
      this.$request1({
        method: 'GET',
        url: '/system/map/supplier-service-type'
      })
        .then(response => {
          this.serviceTypes = response.data;
          if (this.serviceTypes != null && this.serviceTypes.length > 0) {
            this.serviceTypes.forEach(item => {
              this.serviceTypeMap[item.code] = item.name;
            });
          }
        })
        .catch(error => {
          this.$message.error("操作失败");
        });
    },
    // 供应商渠道
    getSupplierChannel(row) {
      row.supplierChannelId = "";
      row.calculationMethod = "";
      row.price = "";
      row.isEdit = false;

      let ids = [];
      let flag = false;
      this.supplierChannelData.forEach(item => {
        if (!ids.includes(item.serviceTypeId)) {
          ids.push(item.serviceTypeId);
        } else {
          row.serviceTypeId = "";
          row.supplierChannelId = "";
          row.calculationMethod = "";
          row.price = "";
          flag = true;
          return;
        }
      });
      if (flag) {
        this.$message({
          message: "该服务类型已存在，请选择其他服务类型",
          type: "warning"
        });
        return;
      }

      this.$request1({
        method: 'GET',
        url: '/system/supplier-all-usable-channel'
      })
        .then(response => {
          row.supplierChannels = response.data;
          if (row.supplierChannels != null && row.supplierChannels.length > 0) {
            row.supplierChannelList = [];
            row.supplierChannels.forEach(item => {
              if (parseInt(item.typeId) == row.serviceTypeId) {
                row.supplierChannelList.push(item);
              }
            });
          }
        })
        .catch(error => {
          this.$message.error("操作失败");
        });
    },
    getSupplierChannelPrice(row) {
      row.isEdit = false;
      row.calculationMethod = "";
      row.price = "";
      row.supplierChannelList.forEach(item => {
        if (item.id == row.supplierChannelId) {
          row.calculationMethod = item.calculationMethod;
          row.price = item.price;
          return;
        }
      });
    },
    editSupplierChannel(row) {
      row.isEdit = true;
      this.uploadDisabled=false
    },
    saveSupplierChannelPrice(row, flag) {
      if (flag) {
        if (!this.checkSupplierChannelPrice(row)) {
          return;
        }
        if(this.supplierChannelPriceForm.img =='') {
          this.$message.warning('请先上传图片');
          return false;
        } 
          this.supplierChannelPriceForm.channelId= row.supplierChannelId,
          this.supplierChannelPriceForm.calculationMethod= row.calculationMethod,
          this.supplierChannelPriceForm.price= Number(row.price) 
        var formData = new FormData();
          for (var key in this.supplierChannelPriceForm) {
            formData.append(key, this.supplierChannelPriceForm[key] ? this.supplierChannelPriceForm[key] : '');
          }  
        this.$request1({
          method: 'POST',
          url: '/system/supplier-channel-price',
          data: formData
        })
          .then(response => {
            if (response.data.success) {
              this.$message({
                message: "成功",
                type: "success"
              });
              row.isEdit = false;
            } else {
              this.$message.error(response.data.message);
            }
          })
          .catch(error => {
            this.$message.error("操作失败");
          });
      } else {
        row.isEdit = false;
        this.getSupplierChannelPrice(row);
      }
    },
    checkSupplierChannel() {
      if (this.isEditSupplierChannelPrice) {
        this.$message({
          message: "请保存计费方式和价格",
          type: "warning"
        });
        return false;
      }
      let flag = true;
      this.supplierChannelData.forEach(item => {
        if (!this.checkSupplierChannelPrice(item)) {
          flag = false;
          return;
        }
      });
      return flag;
    },
    checkSupplierChannelPrice(row) {
      if (row.supplierChannelId.length == 0) {
        this.$message({
          message: "请选择供应商渠道",
          type: "warning"
        });
        return false;
      }
      if (row.calculationMethod == null || row.calculationMethod == "") {
        this.$message({
          message: "请选择供应商渠道计费方式",
          type: "warning"
        });
        return false;
      }
      if (row.price == null || row.price == "" || row.price == 0) {
        this.$message({
          message: "请输入供应商渠道价格",
          type: "warning"
        });
        return false;
      }
      let number = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (!number.test(row.price)) {
        this.$message({
          message: "金额只能为数字，最多保留两位小数，并且不能小于零",
          type: "warning"
        });
        return false;
      }
      return true;
    },
    addRow() {
      let supplierChannelData = {
        supplierChannels: [],
        supplierChannelList: [],
        serviceTypeId: "",
        supplierChannelId: "",
        calculationMethod: "",
        price: "",
        isEdit: false,
        shareType:''
      };
      this.supplierChannelData.push(supplierChannelData);
    },
    removeRow(index) {
      this.supplierChannelData.splice(index, 1);
    },
    
    downloadBatchDetail() {
      if (
        this.downloadBatchDetailStartDate.length == 0 ||
        this.downloadBatchDetailEndDate.length == 0
      ) {
        this.$message({
          message: "请选择开始日期和结束日期",
          type: "warning"
        });
        return;
      }

      this.$request1({
        method: 'GET',
        url: '/batch-operation/download/batch-detail',
        params: {
          startDate: this.downloadBatchDetailStartDate,
          endDate: this.downloadBatchDetailEndDate
        }
      }).then(res => {
        if (!res.data.success) {
          this.$notify.error({
            title: "提示",
            message: res.data.message
          });
          return;
        }
        if (res.data.data) {
          var byteCharacters = atob(res.data.data);

          var byteNumbers = new Array(byteCharacters.length);
          for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          let blob = new Blob([byteArray], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          let objectUrl = URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = objectUrl;
          a.download = "batch_detail_time.xlsx";
          a.click();
        } else {
          this.$notify.error({
            title: "提示",
            message: "导出批次明细时间失败"
          });
        }
        this.batchDetailDialogVisible = false;
      });
    },
       handleChange(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 10) {
        this.$message.error("单张照片限制最大10M");
        this.fileList = [];
      } 
      else {
        this.supplierChannelPriceForm.img = file.raw;
      } if(fileList.length >= 1){
      this.uploadDisabled = true;
    }
    },
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$notify.warning({
        title: "提示",
        message: "只能上传一张图片！"
      });
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
     this. supplierChannelPriceForm.img = null;
     this.uploadDisabled = false;
    },
     // 上传文件之前的钩子
    handleBeforeUpload(file) {
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "提示",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片"
        });
      }
      let size = file.size / 1024 / 1024 / 2;
      if (size > 2) {
        this.$notify.warning({
          title: "提示",
          message: "图片大小必须小于2M"
        });
      }
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //  换算天数 
    getFounder (time,newtime) {
      let filtertime=time.filter(x=>x.attributeKey=='picked_up_at').map(x=>x.attributeValue)[0]
        let day
        if(filtertime && newtime) {
        let now = new Date(filtertime); 
        let sdate = new Date(newtime); 
    　　 let days = Math.ceil(now.getTime()) - Math.floor(sdate.getTime());
        day =Math.floor((days / (1000 * 60 * 60 * 24)));
        if(isNaN(Number(day))) {
          return ''
        }
        if(day==0) {
          return ''
        }
    　　return day + '天';
        }else {
          return ''
        }    
      },
    getTimer (time,newtime) {
      let filtertime=time.filter(x=>x.attributeKey=='delivered_at').map(x=>x.attributeValue)[0]
      let day      
        if(filtertime && newtime) {
        let now = new Date(filtertime); 
        let sdate = new Date(newtime); 
    　　let days = Math.ceil(now.getTime()) - Math.floor(sdate.getTime());
        day =Math.floor((days / (1000 * 60 * 60 * 24))); //30 NaN 
        if(isNaN(Number(day))) {
          return ''
        }
        if(day==0) {
          return ''
        }
    　　return day + '天';
        }else {
          return ''
        }    
    },
    // 点击箱数查看详情 
    async showTrackDetail (id){
      let res=await getTrackList(id);
      if(res.data.success) {
        this.savebatchList=res.data.data;
        this.$store.commit('SAVEBATCHLIST',this.savebatchList)
        this.$store.commit('SAVEBATCHID',id)
        
      } 
      this.countisShow = true;
    },
    // 列是否显示 
    columnshow (x,y) {
      // x=> 签收 y=> 提取 
      let text='';
      if(x==true) {
        text='已签收'
        this.tiqushow=false   
      }
      else if ( y==true) {
        text ='已提取'
        this.qshow=false
      }
     else {
        text ='未提取'
        this.tiqushow=false
      }
      return text
    },
    // input 查询
      //zh 
      async chouseStatus (val) {
        if(val=='未提取' ) {
          let id=this.$store.state.saveid
          let res=await getTrackList(id);
          this.$store.commit('SAVEBATCHID',id)
          this.savebatchList=res.data.data
          let newlist= this.savebatchList.filter(x=>{
           return  x.pickedUp==false;
          })
         this.$store.commit('savewqslist',newlist)
          this.savebatchList=newlist
          // console.log(this.savebatchList)  
        }
        else if(val=='已提取') {
          let id=this.$store.state.saveid
          let res=await getTrackList(id);
          this.$store.commit('SAVEBATCHID',id)
          this.savebatchList=res.data.data;
          let tList=[]
          let lalast=this.savebatchList.filter(x=>{ 
               if(x.pickedUp===true && x.delivered===false) {
                 return x.pickedUp===true
               }
          }) 
          console.log(lalast)
           this.savebatchList=lalast
          this.$store.commit('saveyitiqulist',lalast) 
        }
        else if(val=='已签收') {
          let id=this.$store.state.saveid
          let res=await getTrackList(id);
          this.$store.commit('SAVEBATCHID',id)
          this.savebatchList=res.data.data
          let qslist= this.savebatchList.filter(x=>{
           return  x.delivered==true
          })
          this.$store.commit('saveqslist',qslist);
          let statelist=this.$store.state.saveyitiqulist
          this.savebatchList=qslist
        }
         else if(val=='全部') {
          let id=this.$store.state.saveid
          let res=await getTrackList(id);
          this.$store.commit('SAVEBATCHID',id)
          this.savebatchList=res.data.data
        }
      //  return  this.savebatchList  
      },
      closedialog () {
        this.tableSearch =''
      },
     handleSearch () {
        let input=this.tableSearch
        let list=[];
        let newlist=[]
        let statelist=this.$store.state.saveyitiqulist
        console.log('savebatchList>>>', savebatchList);
        this.savebatchList.forEach(x=>{
          if(input==x.trackingNumber) {
             list.push(x)
             this.savebatchList=list
          } else if(input && this.chouseValue=='已签收') {
            newlist=statelist.filter(x=>{
               if(x.pickedUp===true && x.trackingNumber==input) {
                  return  x.pickedUp===true
               }
          }) 
          this.savebatchList=[...list,...newlist]
          } else if(input=='') {
            let id=this.$store.state.saveid
            getTrackList(id).then(res=>{
              this.savebatchList=res.data.data
            })
          } else if(input.length!==x.trackingNumber.length) {
             this.$toast.error('请输入正确的单号')
          }
        })
      },
      exportTracking(val){
        let id=this.$store.state.saveid
        let url='/batch/tracking_number'
        this.$windowOpen1(url)
      },
      // 签收时间 
      showTimer (time) {
       if (time) {
          let date=new Date(time)
        let y= date.getFullYear();
        let m= date. getMonth()+1;
        let d= date. getDate()
        return y + "-" + m + "-" +d
        } else {
          return '-'
        }
      },
      showTimertwo (time,show) {
        let isshow=false
        if (time && show) {
          let date=new Date(time)
        let y= date.getFullYear();
        let m= date. getMonth()+1;
        let d= date. getDate();
        let s = date.getSeconds();
        return y + "-" + m + "-" +d 
        isshow=true
        } else {
          return false
        }  
      },
    load() {
      this.$toast.success('加载下一页');
      // this.savebatchList = this.savebatchList.concat(this.$store.state.savebatchList);
    },
    //导出子单签出时间
    orderSingOUTExport () {}
  }
};
</script>

<style lang="scss" scoped>
.selected-cartons {
  display: flex;
  height: 32px;
  line-height: 32px;
  > div {
    margin-right: 15px;
  }
}
.add-order__form {
  margin-top: 20px;
}
.el-upload--picture-card,.el-upload--picture-card {
  width: 100px !important;
  height: 100px !important;
  line-height: 100px !important;
}
.el-icon-plus {
  cursor: pointer;
}
.el-icon-plus:hover {
  color: #409eff;
}
.edit-form .sub-label {
  display: inline-block;
  width: 60px;
  margin-right: 10px;
  text-align: right;
  font-size: 12px;
  color: #99a9bf;
}
.edit-form .el-col .el-select.width-inline,
.el-form .el-input.width-inline {
  display: inline-block;
  width: 200px;
}
.table {
  width: 100%;
  thead tr th,
  tbody tr td {
    color: #99a9bf;
    border: 1px dotted #ebeef5;
  }
}
.statistics {
  font-size: 18px;
  height: 32px;
  line-height: 32px;
  margin-bottom: 5px;
  .text {
    color: #969696;
    .total {
      margin: 0 5px;
      color: #3c8dbc;
      font-weight: 400;
    }
  }
  .number {
    color: #3c8dbc;
    margin-right: 10px;
  }
}
</style>
<style>
   .disabled .el-upload--picture-card {
        display: none !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/batchoperation.vue